(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evo-about-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('evo-about-story')) {
  customElements.define('evo-about-story', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.galleryEvents?.abort();
      this.galleryEvents = new AbortController();
      this.setupGalleries();
      const targets = [...this.querySelectorAll('[data-about-reveal]')];
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.isIntersecting) {
          entry.target.classList.remove('is-waiting');
          this.observer.unobserve(entry.target);
        }
      }, { threshold: 0.06, rootMargin: '0px 0px 25px 0px' });
      for (const target of targets) {
        if (target.getBoundingClientRect().top > window.innerHeight) target.classList.add('is-waiting');
        this.observer.observe(target);
      }
    }
    setupGalleries() {
      const options = { signal: this.galleryEvents.signal };
      for (const gallery of this.querySelectorAll('[data-about-gallery]')) {
        const links = [...gallery.querySelectorAll('[data-about-gallery-image]')];
        const dialog = gallery.querySelector('[data-about-gallery-dialog]');
        if (!links.length || typeof dialog?.showModal !== 'function') continue;
        const image = dialog.querySelector('[data-about-gallery-full]');
        const position = dialog.querySelector('[data-about-gallery-position]');
        const close = dialog.querySelector('[data-about-gallery-close]');
        const previous = dialog.querySelector('[data-about-gallery-previous]');
        const next = dialog.querySelector('[data-about-gallery-next]');
        let index = 0;
        let opener;
        const show = newIndex => {
          index = (newIndex + links.length) % links.length;
          image.src = links[index].href;
          image.alt = links[index].querySelector('img')?.alt || '';
          position.textContent = dialog.dataset.positionTemplate
            .replace('__current__', String(index + 1)).replace('__total__', String(links.length));
        };
        previous.disabled = next.disabled = links.length < 2;
        for (const [linkIndex, link] of links.entries()) link.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          opener = link;
          show(linkIndex);
          dialog.showModal();
          document.documentElement.classList.add('evo-about-lightbox-open');
          close.focus({ preventScroll: true });
        }, options);
        close.addEventListener('click', () => dialog.close(), options);
        previous.addEventListener('click', () => show(index - 1), options);
        next.addEventListener('click', () => show(index + 1), options);
        dialog.addEventListener('click', event => {
          if (event.target === dialog || event.target.hasAttribute('data-about-gallery-stage')) dialog.close();
        }, options);
        dialog.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            show(index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('evo-about-lightbox-open');
          if (opener?.isConnected) opener.focus({ preventScroll: true });
        }, options);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      const openDialog = this.querySelector('[data-about-gallery-dialog][open]');
      if (openDialog) {
        openDialog.close();
        document.documentElement.classList.remove('evo-about-lightbox-open');
      }
      this.galleryEvents?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-cinematic-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.evoCreateScrollFilm) return;
  window.evoCreateScrollFilm = ({ root, video, reduced, listen, onModeChange }) => {
    const ui = root.querySelector('[data-scroll-ui]');
    const mode = root.querySelector('[data-scroll-mode]');
    const chapters = root.querySelector('[data-scroll-chapters]');
    const progressBar = root.querySelector('[data-scroll-progress]');
    const phase = root.querySelector('[data-scroll-phase]');
    const steps = [...root.querySelectorAll('[data-scroll-step]')];
    const stage = root.querySelector('.evo-cinematic__inner');
    const header = document.querySelector('.evo-header');
    if (!ui || !mode || !chapters || !progressBar || !phase || !stage) return null;
    let active = false, preferred = true, failed = false, loaded = false, near = false, frame = 0;
    let prepared = '', applied = false, disposed = false;
    const transfer = new AbortController();
    let target = 0, pinTop = 0, currentChapter = -1;
    const eligible = () => !failed && !reduced.matches && !navigator.connection?.saveData && 'IntersectionObserver' in window;
    const measure = () => {
      const rect = header?.getBoundingClientRect();
      const top = rect && rect.top <= 1 ? Math.max(0, Math.min(rect.bottom, innerHeight / 3)) : 0;
      if (pinTop !== top) { pinTop = top; root.style.setProperty('--film-pin-top', `${top}px`); }
    };
    const seek = () => {
      if (!active || document.hidden || video.readyState < 2 || video.seeking || !Number.isFinite(video.duration)) return;
      const destination = Math.max(1 / 24, Math.round(target * Math.max(0, video.duration - 1 / 24) * 24) / 24);
      if (Math.abs(video.currentTime - destination) < 1 / 48) return;
      try { video.currentTime = destination; } catch (_) { }
    };
    const render = () => {
      frame = 0;
      if (!active || document.hidden) return;
      measure();
      const rect = root.getBoundingClientRect();
      const travel = Math.max(1, root.offsetHeight - stage.offsetHeight);
      target = Math.min(1, Math.max(0, (pinTop - rect.top) / travel));
      progressBar.style.transform = `scaleX(${target})`;
      let next = 0;
      steps.forEach((step, index) => { if (target >= Number(step.dataset.at)) next = index; });
      if (next !== currentChapter) {
        currentChapter = next;
        steps.forEach((step, index) => { if (index === next) step.setAttribute('aria-current', 'step'); else step.removeAttribute('aria-current'); });
        phase.textContent = steps[next]?.textContent || '';
      }
      seek();
    };
    const schedule = () => { if (active && !frame && !document.hidden) frame = requestAnimationFrame(render); };
    const applySource = () => {
      if (!active || disposed || !prepared || applied) return;
      applied = true;
      video.src = prepared;
      video.preload = 'auto';
      video.load();
    };
    const load = async () => {
      if (!active || !near || disposed) return;
      if (prepared) { applySource(); return; }
      if (loaded) return;
      loaded = true;
      try {
        const response = await fetch(root.dataset.scrollSrc, { signal: transfer.signal, credentials: 'omit' });
        if (!response.ok) throw new Error('Film unavailable');
        const blob = await response.blob();
        if (disposed) return;
        prepared = URL.createObjectURL(blob);
        applySource();
      } catch (_) { if (!disposed) fail(); }
    };
    const setMode = (enabled, explicit = false) => {
      const next = enabled && eligible();
      const rect = root.getBoundingClientRect();
      const wasPinned = active && rect.top <= pinTop && rect.bottom > pinTop;
      const changed = active !== next;
      active = next;
      ui.hidden = failed;
      mode.hidden = !eligible();
      chapters.hidden = !active;
      mode.textContent = active ? root.dataset.watchLabel : root.dataset.scrollLabel;
      mode.setAttribute('aria-pressed', String(!active));
      if (active) root.setAttribute('data-scroll-active', '');
      else root.removeAttribute('data-scroll-active');
      if (changed) {
        video.pause();
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        measure();
        if (wasPinned || (explicit && active)) window.scrollBy({ top: root.getBoundingClientRect().top - pinTop, behavior: 'instant' });
        onModeChange(active, explicit);
      }
      load();
      schedule();
    };
    const refresh = () => setMode(preferred);
    const fail = () => { failed = true; setMode(false); };
    listen(mode, 'click', () => { preferred = !active; setMode(preferred, true); });
    listen(window, 'scroll', schedule, { passive: true });
    listen(window, 'resize', schedule);
    listen(document, 'visibilitychange', schedule);
    listen(reduced, 'change', refresh);
    if (navigator.connection?.addEventListener) listen(navigator.connection, 'change', refresh);
    ['loadedmetadata', 'loadeddata', 'durationchange', 'seeked'].forEach(event => listen(video, event, schedule));
    listen(video, 'play', () => { if (active) video.pause(); });
    listen(video, 'error', fail);
    video.querySelectorAll('source').forEach(source => listen(source, 'error', fail));
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      near = entries[0].isIntersecting;
      load();
      if (near) schedule();
    }, { rootMargin: '100% 0px' }) : null;
    observer?.observe(root);
    refresh();
    return { get active() { return active; }, refresh, schedule, dispose() { disposed = true; transfer.abort(); observer?.disconnect(); if (frame) cancelAnimationFrame(frame); if (prepared) URL.revokeObjectURL(prepared); } };
  };
})();

(() => {
  if (window.evoCinematicBoot) return;
  window.evoCinematicBoot = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  const formatTime = value => `${Math.floor((value || 0) / 60)}:${String(Math.floor((value || 0) % 60)).padStart(2, '0')}`;
  function init(root) {
    if (controllers.has(root)) return;
    const video = root.querySelector('[data-cinematic-video]');
    const controls = root.querySelector('[data-cinematic-controls]');
    const toggle = root.querySelector('[data-cinematic-toggle]');
    const start = root.querySelector('[data-cinematic-start]');
    const range = root.querySelector('[data-cinematic-range]');
    const time = root.querySelector('[data-cinematic-time]');
    if (!video || !controls || !toggle || !start || !range || !time) return;
    const abort = new AbortController();
    const listen = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: abort.signal });
    let scroll = null;
    let visible = false, attempted = false, userPaused = false, played = false, manual = false, failed = false;
    const update = () => {
      if (failed) return;
      const ended = video.ended;
      const label = ended ? root.dataset.replayLabel : video.paused ? root.dataset.playLabel : root.dataset.pauseLabel;
      toggle.textContent = label;
      start.setAttribute('aria-label', ended ? root.dataset.replayLabel : root.dataset.playLabel);
      start.hidden = !video.paused || (played && !ended);
      range.disabled = !Number.isFinite(video.duration) || video.duration <= 0;
      const position = range.disabled ? 0 : video.currentTime / video.duration;
      range.value = Math.round(position * 1000);
      range.style.setProperty('--film-progress', `${position * 100}%`);
      range.setAttribute('aria-valuetext', `${formatTime(video.currentTime)} / ${formatTime(video.duration)}`);
      time.value = `${formatTime(video.currentTime)}${range.disabled ? '' : ' / ' + formatTime(video.duration)}`;
    };
    const play = async explicit => {
      if (failed) return;
      if (explicit) { manual = true; userPaused = false; if (video.ended) video.currentTime = 0; }
      try { await video.play(); played = true; if (document.hidden || (!explicit && !visible)) video.pause(); }
      catch (_) { video.pause(); }
      update();
    };
    const activate = () => {
      if (video.paused || video.ended) play(true);
      else { userPaused = true; video.pause(); }
    };
    listen(toggle, 'click', activate);
    listen(start, 'click', activate);
    listen(range, 'input', () => { if (Number.isFinite(video.duration)) video.currentTime = Number(range.value) / 1000 * video.duration; update(); });
    ['timeupdate', 'durationchange', 'loadedmetadata', 'play', 'pause', 'ended'].forEach(event => listen(video, event, update));
    const fail = () => { failed = true; video.pause(); controls.hidden = true; start.hidden = true; video.controls = true; root.removeAttribute('data-enhanced'); };
    listen(video, 'error', fail);
    video.querySelectorAll('source').forEach(source => listen(source, 'error', fail));
    const canAutoPlay = () => !root.hasAttribute('data-scroll-film') && !reduced.matches && !navigator.connection?.saveData;
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .4;
      if (scroll?.active) { video.pause(); scroll.schedule(); return; }
      if (!visible) video.pause();
      else if (!document.hidden && !userPaused && !video.ended) {
        if (!attempted && canAutoPlay()) { attempted = true; play(false); }
        else if (played && (manual || canAutoPlay())) play(false);
      }
    }, { threshold: [0, .4, 1] }) : null;
    observer?.observe(video);
    listen(document, 'visibilitychange', () => {
      if (document.hidden) video.pause();
      else if (!scroll?.active && visible && played && !video.ended && !userPaused && (manual || canAutoPlay())) play(false);
    });
    listen(reduced, 'change', () => { if (reduced.matches) { video.pause(); manual = false; userPaused = true; } });
    video.controls = false;
    video.muted = true;
    controls.hidden = false;
    root.dataset.enhanced = '';
    if (root.hasAttribute('data-scroll-film')) scroll = window.evoCreateScrollFilm?.({ root, video, reduced, listen, onModeChange(active, explicit) { if (!active && explicit) play(true); else update(); } });
    update();
    controllers.set(root, () => { video.pause(); observer?.disconnect(); scroll?.dispose(); abort.abort(); controllers.delete(root); });
  }
  const boot = container => container.querySelectorAll('[data-cinematic]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of controllers) if (event.target.contains(root)) dispose();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const uiNode = document.getElementById('evo-ui');
  if (!uiNode) return;
  const config = JSON.parse(uiNode.textContent);
  const ui = config.strings;
  const root = config.root || '/';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const money = cents => new Intl.NumberFormat('en-IE', {style:'currency',currency:config.currency || 'EUR'}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const $ = (selector, scope=document) => scope.querySelector(selector);
  const $$ = (selector, scope=document) => Array.from(scope.querySelectorAll(selector));
  let cartBusy = false;
  let lastFocus;
  function openDialog(dialog, trigger) {
    if (!dialog) return;
    lastFocus = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
    document.documentElement.style.overflow = '';
    if (lastFocus?.isConnected) lastFocus.focus();
  }
  $$('.evo-dialog').forEach(dialog => {
    dialog.addEventListener('cancel', () => { document.documentElement.style.overflow=''; });
    dialog.addEventListener('close', () => { document.documentElement.style.overflow=''; });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box=dialog.getBoundingClientRect(); if(event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom) closeDialog(dialog); } });
  });
  document.addEventListener('click', async event => {
    const close=event.target.closest('[data-close-dialog]');
    if(close) closeDialog(close.closest('dialog'));
    const toggle=event.target.closest('[data-panel-toggle]');
    if(toggle){const panel=document.getElementById(toggle.dataset.panelToggle);const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));panel.hidden=expanded;if(!expanded)$('input',panel)?.focus();}
    const cart=event.target.closest('[data-cart-open]');
    if(cart){event.preventDefault();openDialog($('#evo-cart-dialog'),cart);await loadCart();}
    const quantity=event.target.closest('[data-quantity-step]');
    if(quantity){const container=quantity.closest('.evo-qty');const input=$('input',container);const min=Number(input.min)||1;const max=Number(input.max)||999;const value=Math.min(max,Math.max(min,(Number(input.value)||min)+Number(quantity.dataset.quantityStep)));if(value!==Number(input.value)){input.value=value;input.dispatchEvent(new Event('change',{bubbles:true}));}}
    const remove=event.target.closest('[data-cart-remove]');
    if(remove) changeCart(remove.dataset.cartRemove,0);
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){$$('[data-panel-toggle][aria-expanded="true"]').forEach(button=>{button.setAttribute('aria-expanded','false');document.getElementById(button.dataset.panelToggle).hidden=true;button.focus();});$$('.evo-nav details[open]').forEach(el=>el.open=false);}});
  document.addEventListener('click',event=>{$$('.evo-nav details[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;});});
  function renderCart(cart){
    $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const lines=cart.items.map(item=>{
      const image=item.featured_image?.url || item.image;
      const quantityId='quantity-'+item.key.replace(/[^a-z0-9]/gi,'');
      return `<article class="evo-cart-line"><a href="${escape(item.url)}">${image?`<img src="${escape(image)}${image.includes('?')?'&':'?'}width=260" alt="${escape(item.product_title)}" width="130" height="150" loading="lazy">`:''}</a><div><div class="evo-cart-line__top"><a href="${escape(item.url)}">${escape(item.product_title)}</a><span>${money(item.final_line_price)}</span></div><p class="evo-cart-line__details">${escape(item.variant_title || '')}</p><div class="evo-cart-line__controls"><div class="evo-qty"><button type="button" data-quantity-step="-1" aria-label="${escape(ui.decrease)}">−</button><label class="evo-sr" for="${quantityId}">${escape(ui.quantity)}</label><input id="${quantityId}" type="number" value="${item.quantity}" min="1" max="99" inputmode="numeric" data-cart-quantity="${escape(item.key)}"><button type="button" data-quantity-step="1" aria-label="${escape(ui.increase)}">+</button></div><button type="button" class="evo-remove" data-cart-remove="${escape(item.key)}">${escape(ui.remove)}</button></div></div></article>`;
    }).join('');
    const html=cart.item_count?`${lines}<div class="evo-cart-total"><span>${escape(ui.subtotal)}</span><span>${money(cart.total_price)}</span></div><p class="evo-small">${escape(ui.checkout_note)}</p><form action="${root}cart" method="post"><button type="submit" name="checkout" class="evo-btn evo-cart-checkout">${escape(ui.checkout)} <span aria-hidden="true">↗</span></button></form><a class="evo-link" href="${root}collections/jewelry" style="margin-top:20px">${escape(ui.continue)}</a>`:`<div class="evo-cart-empty"><p>${escape(ui.empty)}</p><a href="${root}collections/jewelry" class="evo-btn">${escape(ui.explore)}</a></div>`;
    $$('[data-cart-content]').forEach((node,index)=>{node.innerHTML=html.replaceAll('id="quantity-',`id="quantity-${index}-`).replaceAll('for="quantity-',`for="quantity-${index}-`);});
  }
  function cartError(message){$$('[data-cart-error]').forEach(node=>{node.textContent=message;node.hidden=!message;});}
  async function loadCart(){cartError('');try{const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)throw Error(ui.cart_error);const cart=await response.json();renderCart(cart);}catch(error){cartError(error.message || ui.cart_error);}}
  async function changeCart(id,quantity){
    if(cartBusy)return;
    cartBusy=true;cartError('');
    $$('[data-cart-content]').forEach(node=>{node.setAttribute('aria-busy','true');$$('button,input',node).forEach(el=>el.disabled=true);});
    try{const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id,quantity})});const result=await response.json();if(!response.ok)throw Error(result.description || result.message || ui.cart_error);renderCart(result);$('#evo-announcer').textContent=ui.cart_updated;}
    catch(error){await loadCart();cartError(error.message || ui.cart_error);}
    finally{cartBusy=false;$$('[data-cart-content]').forEach(node=>{node.removeAttribute('aria-busy');$$('button,input',node).forEach(el=>el.disabled=false);});}
  }
  document.addEventListener('change',event=>{const input=event.target.closest('[data-cart-quantity]');if(input){const value=Number(input.value);if(!Number.isInteger(value)||value<1){input.value=1;return;}changeCart(input.dataset.cartQuantity,value);}});
  function initProduct(section){
    if(section.dataset.ready)return;section.dataset.ready='true';
    const dataNode=$('[data-variants]',section);if(!dataNode)return;
    const variants=JSON.parse(dataNode.textContent);
    const form=$('[data-product-form]',section);
    const select=$('select[name="id"]',form);
    const fieldsets=$$('[data-option-position]',form);
    const chainConfirmed=section.dataset.chainConfirmed==='true';
    const permitted=variant=>variant?.available && (chainConfirmed || !variant.options.some(value=>/chain/i.test(value) && !/only|without|no chain/i.test(value)));
    const error=$('[data-product-error]',section);
    const submit=$('[data-add-button]',section);
    const label=$('[data-add-label]',section);
    $('[data-native-variants]',form).hidden=true;
    $('[data-enhanced-variants]',form).hidden=false;
    const selection=()=>fieldsets.map(field=>$('input:checked',field)?.value);
    function refresh(updateUrl=true){
      const options=selection();
      const selected=variants.find(variant=>variant.options.every((value,index)=>value===options[index]));
      fieldsets.forEach((field,index)=>{$$('input',field).forEach(input=>{input.disabled=!variants.some(variant=>permitted(variant)&&variant.options[index]===input.value&&variant.options.every((value,j)=>j>=index||value===options[j]));});});
      submit.disabled=!permitted(selected);
      label.textContent=permitted(selected)?ui.add:ui.unavailable;
      if(selected){select.value=String(selected.id);$('[data-product-price]',section).textContent=money(selected.price);if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',selected.id);history.replaceState({},'',url);}}
      const note=$('[data-chain-note]',section);if(note)note.textContent=options.some(value=>/chain/i.test(value||'')&&!/only|without|no chain/i.test(value||''))?ui.chain_unavailable:ui.chain_not_included;
      error.hidden=true;
    }
    fieldsets.forEach(field=>field.addEventListener('change',()=>refresh()));refresh(false);
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(form.dataset.busy==='true')return;
      const variant=variants.find(v=>String(v.id)===select.value);
      if(!permitted(variant))return;
      const quantity=Number($('[name="quantity"]',form)?.value||1);
      if(!Number.isInteger(quantity)||quantity<1){error.textContent=ui.quantity_error;error.hidden=false;return;}
      form.dataset.busy='true';submit.disabled=true;label.textContent=ui.adding;error.hidden=true;
      try{const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity}]})});const result=await response.json();if(!response.ok)throw Error(result.description || result.message || ui.add_error);await loadCart();$('#evo-announcer').textContent=ui.added;openDialog($('#evo-cart-dialog'),submit);}
      catch(failure){error.textContent=failure.message || ui.add_error;error.hidden=false;}
      finally{form.dataset.busy='false';submit.disabled=!permitted(variant);label.textContent=ui.add;}
    });
    const main=$('[data-gallery-main]',section);
    $$('[data-gallery-thumb]',section).forEach(button=>button.addEventListener('click',()=>{main.src=button.dataset.src;main.srcset=button.dataset.srcset||'';main.alt=button.dataset.alt;$$('[data-gallery-thumb]',section).forEach(el=>el.setAttribute('aria-pressed',String(el===button)));}));
    $('[data-gallery-zoom]',section)?.addEventListener('click',event=>{const dialog=$('#evo-lightbox');const image=$('img',dialog);image.src=main.currentSrc||main.src;image.alt=main.alt;openDialog(dialog,event.currentTarget);});
  }
  function initStory(story){
    if(story.dataset.ready)return;story.dataset.ready='true';
    const steps=$$('[data-story-step]',story),frames=$$('[data-story-frame]',story),links=$$('[data-story-nav]',story);
    const scene=$('.evo-story__scene',story),caption=$('[data-story-caption]',story),label=$('[data-story-label]',story);
    let active=-1,scheduled=false,timer=null;
    function activate(index){if(index===active||index<0)return;const previous=active;active=index;steps.forEach((step,i)=>step.classList.toggle('is-current',i===index));frames.forEach((frame,i)=>{frame.classList.toggle('is-active',i===index);frame.setAttribute('aria-hidden',String(i!==index));});links.forEach((link,i)=>{link.classList.toggle('is-active',i===index);if(i===index)link.setAttribute('aria-current','step');else link.removeAttribute('aria-current');});if(caption)caption.textContent=frames[index]?.dataset.caption||'';if(label)label.textContent=String(index+1).padStart(2,'0')+' / '+steps.length+' — '+(steps[index]?.dataset.title||'');if(scene){scene.dataset.phase=frames[index]?.dataset.kind||'';if(index===1&&previous===0&&!reduced.matches){scene.classList.remove('is-assembling');requestAnimationFrame(()=>scene.classList.add('is-assembling'));}}}
    function sync(){scheduled=false;if(timer||window.innerWidth<768)return;const center=innerHeight*.55;let nearest=0,distance=Infinity;steps.forEach((step,i)=>{const rect=step.getBoundingClientRect();const diff=Math.abs((rect.top+rect.bottom)/2-center);if(diff<distance){distance=diff;nearest=i;}});activate(nearest);}
    const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting))sync();},{threshold:0});observer.observe(story);
    window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sync);}},{passive:true});
    links.forEach((link,i)=>link.addEventListener('click',event=>{if(window.innerWidth<768)event.preventDefault();if(timer){clearInterval(timer);timer=null;const button=$('[data-story-play]',story);if(button)button.textContent=ui.play;}activate(i);}));
    const play=$('[data-story-play]',story);play?.addEventListener('click',()=>{if(timer){clearInterval(timer);timer=null;play.textContent=ui.play;return;}if(reduced.matches){activate((active+1)%steps.length);return;}activate(0);play.textContent=ui.pause;timer=setInterval(()=>{if(active>=steps.length-1){clearInterval(timer);timer=null;play.textContent=ui.play;}else activate(active+1);},2400);});
    activate(0);
  }
  function init(rootNode=document){
    $$('[data-product-section]',rootNode).forEach(initProduct);
    $$('[data-story]',rootNode).forEach(initStory);
    if(!reduced.matches && 'IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('is-pending');entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.08,rootMargin:'0px 0px -25px 0px'});$$('.evo-reveal:not(.is-visible)',rootNode).forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('is-pending');observer.observe(el);}});}
  }
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>{const step=event.target.closest('[data-story-step]');if(step)step.scrollIntoView({block:'center',behavior:'auto'});});
  if($('[data-cart-page]'))loadCart();
  window.addEventListener('pageshow',event=>{if(event.persisted)loadCart();});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-form-process-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.evoFormProcessLoaded) return;
  window.evoFormProcessLoaded = true;
  const models = {"unda":{"code":"007","handle":"unda-titanium-pendant","model_url":"https://cdn.shopify.com/3d/models/5ebbc8381712899a/elovium-eln-007-interactive.glb","poster":"https://cdn.shopify.com/s/files/1/1025/5699/1823/files/elovium-eln-007-interactive.png?v=1790466145"},"ramus":{"code":"001","handle":"ramus-titanium-necklace","model_url":"https://cdn.shopify.com/3d/models/5e19336f5572eb43/elovium-eln-001-interactive.glb","poster":"https://cdn.shopify.com/s/files/1/1025/5699/1823/files/elovium-eln-001-interactive.png?v=1790466145"}};
  const cleanups = new WeakMap();
  const phases = ['nature', 'form', 'digital', 'layers', 'finish'];
  const durations = [7, 9, 6, 10, 7];
  const starts = durations.map((_, i) => durations.slice(0, i).reduce((a, b) => a + b, 0));
  const duration = durations.reduce((a, b) => a + b, 0);
  const clamp = (n, a = 0, b = 1) => Math.max(a, Math.min(b, n));
  const ease = n => n * n * (3 - 2 * n);
  const seed = n => { const value = Math.sin(n * 127.1 + 311.7) * 43758.5453; return value - Math.floor(value); };
  const init = root => {
    if (cleanups.has(root)) return;
    const abort = new AbortController(), signal = abort.signal;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const canvas = root.querySelector('[data-form-nature]'), context = canvas?.getContext('2d');
    const viewers = [...root.querySelectorAll('[data-form-viewer]')];
    const modelButtons = [...root.querySelectorAll('[data-form-model]')];
    const stageButtons = [...root.querySelectorAll('[data-form-stage]')];
    const chapters = [...root.querySelectorAll('[data-form-chapter]')];
    const toggle = root.querySelector('[data-form-toggle]');
    const range = root.querySelector('[data-form-range]');
    const output = root.querySelector('[data-form-output]');
    const chapterNumber = root.querySelector('[data-form-number]');
    const modelLabel = root.querySelector('[data-form-model-label]');
    const stageLabel = root.querySelector('[data-form-stage-label]');
    const status = root.querySelector('[data-form-status]');
    let model = root.dataset.model || 'unda';
    let elapsed = reduced.matches || navigator.connection?.saveData ? duration : 0;
    let paused = reduced.matches || !!navigator.connection?.saveData;
    let visible = false, raf = 0, previous = 0, width = 1, height = 1, phaseIndex = -1;
    const activeViewer = () => viewers.find(viewer => viewer.dataset.formViewer === model);
    const locate = () => {
      let index = starts.findIndex((start, i) => elapsed < start + durations[i]);
      if (index < 0) index = phases.length - 1;
      return { index, phase: phases[index], progress: clamp((elapsed - starts[index]) / durations[index]) };
    };
    const running = () => visible && !paused && !document.hidden && elapsed < duration;
    const water = time => {
      const glow = context.createRadialGradient(width * .42, height * .55, 0, width * .48, height * .52, width * .62);
      glow.addColorStop(0, 'rgba(116,150,143,.12)');glow.addColorStop(.5, 'rgba(63,103,99,.08)');glow.addColorStop(1, 'rgba(9,23,22,0)');
      context.fillStyle = glow;context.fillRect(0, 0, width, height);
      for (let lane = 0; lane < 62; lane++) {
        const y = lane / 62, strength = Math.sin(y * Math.PI);
        context.beginPath();
        for (let point = 0; point <= 100; point++) {
          const x = point / 100;
          const drift = Math.sin(x * 6.5 + y * 4.2 + time * .3) * .065 + Math.sin(x * 15 - y * 8 - time * .16) * .018;
          const px = x * width, py = (y * .96 + .02 + drift * strength) * height;
          if (!point) context.moveTo(px, py);else context.lineTo(px, py);
        }
        context.strokeStyle = `rgba(160,194,183,${(.07 + seed(lane) * .18) * strength})`;
        context.lineWidth = (lane % 9 ? .6 : 1.15) * width / 1200;context.stroke();
      }
      for (let i = 0; i < 110; i++) {
        const x = (seed(i + 2) + time * (.004 + seed(i) * .007)) % 1;
        const row = seed(i + 17);
        const y = row + Math.sin(x * 6.5 + row * 4.2 + time * .3) * .065 * Math.sin(row * Math.PI);
        context.fillStyle = `rgba(191,210,196,${.08 + seed(i + 6) * .22})`;
        context.beginPath();context.arc(x * width, y * height, .6 + seed(i + 3) * 1.1, 0, Math.PI * 2);context.fill();
      }
    };
    const branches = time => {
      const growth = .88 + Math.sin(time * .16) * .03;
      const branch = (x, y, length, angle, depth, id) => {
        if (!depth) return;
        const sway = Math.sin(time * .28 + id * .4) * .018;
        const tx = x + Math.cos(angle + sway) * length, ty = y + Math.sin(angle + sway) * length;
        context.beginPath();context.moveTo(x, y);
        context.quadraticCurveTo(x + Math.cos(angle - .12) * length * .55, y + Math.sin(angle - .12) * length * .55, tx, ty);
        context.strokeStyle = `rgba(166,183,151,${.05 + depth * .04})`;context.lineWidth = Math.max(.35, depth * .32 * width / 1000);context.stroke();
        const split = .3 + seed(id + 11) * .38;
        branch(tx, ty, length * (.62 + seed(id + 1) * .08), angle - split, depth - 1, id * 2 + 1);
        branch(tx, ty, length * (.61 + seed(id + 2) * .11), angle + split * .91, depth - 1, id * 2 + 2);
      };
      const glow = context.createRadialGradient(width * .5, height * .46, 0, width * .5, height * .46, width * .5);
      glow.addColorStop(0, 'rgba(119,131,92,.09)');glow.addColorStop(1, 'rgba(40,53,39,0)');context.fillStyle = glow;context.fillRect(0, 0, width, height);
      branch(width * .5, height * 1.12, height * .3 * growth, -Math.PI / 2, 9, 1);
      for (let i = 0; i < 90; i++) {
        const x = seed(i + 88), y = (seed(i + 81) - time * .003 + 1) % 1;
        context.fillStyle = `rgba(188,199,165,${.04 + seed(i + 1) * .1})`;context.beginPath();context.arc(x * width, y * height, .6 + seed(i + 3), 0, Math.PI * 2);context.fill();
      }
    };
    const paintNature = state => {
      if (!context) return;
      context.clearRect(0, 0, width, height);
      const alpha = state.phase === 'nature' ? 1 : state.phase === 'form' ? 1 - ease(clamp(state.progress * 1.35)) : state.phase === 'finish' ? ease(state.progress) * .08 : 0;
      if (alpha <= 0) return;
      context.globalAlpha = alpha;
      if (model === 'unda') water(elapsed);else branches(elapsed);
      context.globalAlpha = 1;
    };
    const updateButton = () => {
      const completed = elapsed >= duration;
      const text = completed ? root.dataset.replayLabel : paused ? root.dataset.playLabel : root.dataset.pauseLabel;
      if (toggle.textContent !== text) toggle.textContent = text;
      toggle.setAttribute('aria-label', text);toggle.setAttribute('aria-pressed', String(!paused && !completed));
      root.dataset.playing = String(running());
    };
    const draw = () => {
      const state = locate();
      root.dataset.phase = state.phase;
      root.style.setProperty('--story-progress', String(elapsed / duration));
      activeViewer()?.setStage?.(state.phase, state.progress);
      paintNature(state);
      range.value = String(Math.round(elapsed / duration * 1000));
      output.textContent = `0:${String(Math.floor(elapsed)).padStart(2, '0')} / 0:${Math.round(duration)}`;
      range.setAttribute('aria-valuetext', `${stageButtons[state.index].dataset.stageLabel}, ${Math.round(state.progress * 100)}%`);
      stageButtons.forEach((button, i) => button.style.setProperty('--chapter-progress', String(i < state.index ? 1 : i === state.index ? state.progress : 0)));
      if (phaseIndex !== state.index) {
        phaseIndex = state.index;
        stageButtons.forEach((button, i) => {button.setAttribute('aria-pressed', String(i === phaseIndex));button.setAttribute('aria-current', i === phaseIndex ? 'step' : 'false');});
        chapters.forEach(chapter => {chapter.hidden = chapter.dataset.formChapter !== state.phase;});
        chapterNumber.textContent = `0${state.index + 1}`;
        stageLabel.textContent = stageButtons[state.index].dataset.stageLabel;
        status.textContent = stageButtons[state.index].dataset.stageLabel;
      }
      updateButton();
    };
    const tick = now => {
      raf = 0;
      if (!running()) {previous = 0;updateButton();return;}
      const step = previous ? Math.min((now - previous) / 1000, .06) : 0;previous = now;
      const loading = elapsed >= starts[1] - .08 && elapsed < starts[1] && !activeViewer()?.modelReady;
      elapsed = Math.min(duration, elapsed + (loading ? 0 : step));draw();
      if (running()) raf = requestAnimationFrame(tick);else {paused = true;activeViewer()?.pause?.();updateButton();}
    };
    const schedule = () => {
      cancelAnimationFrame(raf);raf = 0;previous = 0;
      viewers.forEach(viewer => {if (running() && viewer === activeViewer()) viewer.resume?.();else viewer.pause?.();});
      updateButton();
      if (running()) raf = requestAnimationFrame(tick);
    };
    const selectModel = next => {
      model = next;root.dataset.model = model;
      viewers.forEach(viewer => {viewer.hidden = viewer.dataset.formViewer !== model;});
      modelButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.formModel === model)));
      root.querySelectorAll('[data-form-nature-copy]').forEach(copy => {copy.hidden = copy.dataset.formNatureCopy !== model;});
      modelLabel.textContent = model.toUpperCase();draw();schedule();
    };
    viewers.forEach(viewer => {
      const record = models[viewer.dataset.formViewer];
      if (record?.model_url) viewer.setAttribute('data-model-url', record.model_url);
      if (record?.poster && !record.poster.startsWith('shopify:')) viewer.setAttribute('data-poster', record.poster);
      viewer.addEventListener('model-loaded', draw, {signal});
      viewer.addEventListener('model-error', () => {root.dataset.modelUnavailable = 'true';}, {signal});
    });
    modelButtons.forEach(button => button.addEventListener('click', () => selectModel(button.dataset.formModel), {signal}));
    stageButtons.forEach((button, index) => button.addEventListener('click', () => {
      elapsed = starts[index] + (paused ? durations[index] * .58 : 0);draw();schedule();
    }, {signal}));
    toggle.addEventListener('click', () => {
      if (elapsed >= duration) {elapsed = 0;paused = false;}else paused = !paused;
      draw();schedule();
    }, {signal});
    range.addEventListener('input', () => {elapsed = Number(range.value) / 1000 * duration;paused = true;draw();schedule();}, {signal});
    const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;schedule();}, {threshold:.18});observer.observe(root.querySelector('.evo-process-form__stage'));
    const resize = new ResizeObserver(() => {
      if (!canvas || !context) return;
      const box = canvas.parentElement.getBoundingClientRect();width = Math.max(1, box.width);height = Math.max(1, box.height);
      const ratio = Math.min(devicePixelRatio || 1, 2);canvas.width = Math.round(width * ratio);canvas.height = Math.round(height * ratio);context.setTransform(ratio, 0, 0, ratio, 0, 0);paintNature(locate());
    });resize.observe(canvas.parentElement);
    reduced.addEventListener('change', () => {if (reduced.matches) {elapsed = duration;paused = true;draw();schedule();}}, {signal});
    document.addEventListener('visibilitychange', schedule, {signal});
    root.querySelectorAll('[data-form-interactive]').forEach(element => {element.hidden = false;});
    root.dataset.ready = 'true';selectModel(model);
    customElements.whenDefined('evo-model-viewer').then(() => {if (!signal.aborted) {draw();schedule();}});
    cleanups.set(root, () => {cancelAnimationFrame(raf);resize.disconnect();observer.disconnect();abort.abort();});
  };
  const all = (scope = document) => scope.querySelectorAll('[data-form-process]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => all(), {once:true});else all();
  document.addEventListener('shopify:section:load', event => all(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-form-process]').forEach(root => {cleanups.get(root)?.();cleanups.delete(root);}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-hero-film-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('evo-hero-film')) return;
  class HeroFilm extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-film-toggle]');
      this.mobile = matchMedia('(max-width: 767px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true;
      this.finished = false;
      this.userPaused = false;
      this.toggle.hidden = false;
      this.setSource();
      this.video.addEventListener('timeupdate', () => this.updatePhase(), {signal});
      this.video.addEventListener('playing', () => {
        this.classList.add('is-playing', 'has-frame');
        this.dataset.playback = 'playing';
        this.toggle.textContent = this.dataset.pauseLabel;
        this.updatePhase();
      }, {signal});
      this.video.addEventListener('pause', () => {
        this.classList.remove('is-playing');
        if (!this.finished) {
          this.dataset.playback = 'paused';
          this.toggle.textContent = this.dataset.playLabel;
        }
      }, {signal});
      this.video.addEventListener('ended', () => {
        this.finished = true;
        this.dataset.phase = 'final';
        this.dataset.playback = 'ended';
        this.toggle.textContent = this.dataset.replayLabel;
        this.classList.remove('is-playing');
      }, {signal});
      this.video.addEventListener('error', () => {
        this.classList.remove('has-frame', 'is-playing');
        this.dataset.phase = 'final';
        this.dataset.playback = 'fallback';
        this.toggle.textContent = this.dataset.playLabel;
      }, {signal});
      this.toggle.addEventListener('click', () => {
        if (!this.video.paused) {
          this.userPaused = true;
          this.video.pause();
        } else {
          this.userPaused = false;
          if (this.finished) { this.finished = false; this.video.currentTime = 0; }
          this.play();
        }
      }, {signal});
      this.mobile.addEventListener('change', () => this.changeSource(), {signal});
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) {
          this.userPaused = true;
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.classList.remove('has-frame', 'is-playing');
          this.dataset.phase = 'final';
          this.dataset.playback = 'reduced';
        }
      }, {signal});
      const visibility = () => {
        if (document.hidden || !this.visible) {
          this.resumeWhenVisible = !this.video.paused;
          this.video.pause();
        } else if (this.resumeWhenVisible && !this.userPaused && !this.finished && !this.reduced.matches) {
          this.resumeWhenVisible = false;
          this.play();
        }
      };
      document.addEventListener('visibilitychange', visibility, {signal});
      this.observer = new IntersectionObserver(entries => {
        const visible = entries[0].isIntersecting;
        if (visible !== this.visible) { this.visible = visible; visibility(); }
      }, {threshold:0.1});
      this.observer.observe(this);
      if (!this.reduced.matches && !navigator.connection?.saveData && !document.hidden) this.play();
      else this.dataset.playback = this.reduced.matches ? 'reduced' : 'idle';
    }
    setSource() {
      this.source = this.mobile.matches ? (this.dataset.mobile || this.dataset.desktop) : this.dataset.desktop;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = false;
      this.dataset.device = this.mobile.matches ? 'mobile' : 'desktop';
    }
    async play() {
      if (!this.source) return;
      if (this.video.getAttribute('src') !== this.source) {
        this.video.src = this.source;
        this.video.load();
      }
      this.video.muted = true;
      try { await this.video.play(); }
      catch (error) {
        if (error.name === 'AbortError') return;
        this.dataset.playback = 'blocked';
        this.toggle.textContent = this.dataset.playLabel;
        if (!this.classList.contains('has-frame')) this.dataset.phase = 'final';
      }
    }
    changeSource() {
      const at = this.video.currentTime || 0;
      const playing = !this.video.paused;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.classList.remove('has-frame', 'is-playing');
      this.setSource();
      if (this.finished || this.reduced.matches) { this.dataset.phase = 'final'; return; }
      if (playing || at > 0) {
        this.video.addEventListener('loadedmetadata', () => {
          this.video.currentTime = Math.min(at, this.video.duration - 0.05);
          if (playing) this.play();
          else this.video.addEventListener('seeked', () => this.classList.add('has-frame'), {once:true,signal:this.abort.signal});
        }, {once:true,signal:this.abort.signal});
        this.video.src = this.source;
        this.video.load();
      }
    }
    updatePhase() {
      const at = this.video.currentTime;
      this.dataset.phase = at >= 13.5 ? 'final' : at >= 10.791667 ? 'wear' : 'nature';
    }
    disconnectedCallback() {
      this.video?.pause();
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
    }
  }
  customElements.define('evo-hero-film', HeroFilm);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-local-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.evoInteractiveGalleryLoaded) return;
  window.evoInteractiveGalleryLoaded = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 767px)');
  const cleanup = new WeakMap();
  const collectionCleanup = new WeakMap();
  const initializeCollection = () => document.querySelectorAll('[data-collection-view]').forEach(root => {
    const gallery = document.querySelector('[data-collection-gallery]');
    if (!gallery) {collectionCleanup.get(root)?.dispose();return;}
    if (collectionCleanup.has(root)) {collectionCleanup.get(root).refresh(gallery);return;}
    const controller = new AbortController(), {signal} = controller;
    const tabs = [...root.querySelectorAll('[data-collection-tab]')];
    const images = document.getElementById(tabs[0].getAttribute('aria-controls'));
    let modelPanel = gallery;
    const show = view => {
      root.dataset.view = view;images.hidden = view !== 'images';modelPanel.hidden = view !== 'models';
      tabs.forEach(tab => {const active = tab.dataset.collectionTab === view;tab.setAttribute('aria-selected', String(active));tab.tabIndex = active ? 0 : -1;});
    };
    const refresh = panel => {
      modelPanel = panel;tabs[1].setAttribute('aria-controls', panel.id);panel.setAttribute('aria-labelledby', tabs[1].id);
      root.querySelector('[data-collection-tabs]').hidden = false;show(root.dataset.view || 'images');
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => show(tab.dataset.collectionTab), {signal});
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
        show(tabs[next].dataset.collectionTab);tabs[next].focus({preventScroll:true});
      }, {signal});
    });
    collectionCleanup.set(root, {refresh,dispose:()=>{show('images');root.querySelector('[data-collection-tabs]').hidden=true;controller.abort();collectionCleanup.delete(root);}});refresh(gallery);
  });
  const galleries = root => [...(root.matches?.('[data-form-gallery]') ? [root] : []), ...root.querySelectorAll('[data-form-gallery]')];
  const initialize = root => galleries(root).forEach(section => {
    if (cleanup.has(section)) return;
    const controller = new AbortController(), {signal} = controller;
    const listen = (target, event, callback) => target?.addEventListener(event, callback, {signal});
    const items = [...section.querySelectorAll('[data-form-item]')];
    const viewers = items.map(item => item.querySelector('[data-form-viewer]'));
    const pause = section.querySelector('[data-forms-pause]');
    const dialog = section.querySelector('[data-form-dialog]');
    const dialogModel = section.querySelector('[data-form-dialog-model]');
    let manualPause = reduce.matches || !!navigator.connection?.saveData, opener = null;
    const playback = () => {
      pause.textContent = manualPause ? pause.dataset.play : pause.dataset.pause;
      pause.setAttribute('aria-pressed', String(manualPause));
      [...viewers, ...dialogModel.querySelectorAll('evo-model-viewer')].forEach(viewer => {
        if (manualPause) viewer.setAttribute('paused', '');else viewer.removeAttribute('paused');
      });
    };
    listen(pause, 'click', () => {manualPause = !manualPause;playback();});
    items.forEach(item => {
      const productLink = item.querySelector('[data-form-product]'), viewer = item.querySelector('[data-form-viewer]');
      let pointerStart = null, dragged = false;
      const active = value => item.classList.toggle('is-active', value);
      listen(item, 'mouseenter', () => {if (!mobile.matches) active(true);});
      listen(item, 'mouseleave', () => {if (!item.contains(document.activeElement)) active(false);});
      listen(item, 'focusin', () => {if (!mobile.matches) active(true);});
      listen(item, 'focusout', () => {queueMicrotask(() => {if (!signal.aborted && !item.contains(document.activeElement)) active(false);});});
      listen(item, 'pointerdown', event => {if(event.button !== 0)return;pointerStart = [event.clientX, event.clientY];dragged = false;});
      listen(item, 'pointermove', event => {if (pointerStart && Math.hypot(event.clientX - pointerStart[0], event.clientY - pointerStart[1]) >= 7) dragged = true;});
      listen(item, 'pointerup', () => {pointerStart = null;});
      listen(item, 'pointercancel', () => {pointerStart = null;dragged = true;});
      listen(item, 'click', event => {
        if (dragged && event.detail !== 0) {event.preventDefault();dragged = false;return;}
        if (event.target.closest('a,button') || event.button !== 0) return;
        productLink.click();
      });
      listen(viewer, 'keydown', event => {if (event.key === 'Enter' || event.key === ' ') {event.preventDefault();productLink.click();}});
      listen(item.querySelector('[data-form-inspect]'), 'click', event => {
        if (!item.dataset.modelUrl) return;
        opener = event.currentTarget;
        section.querySelector('[data-form-dialog-name]').textContent = item.dataset.name;
        const full = document.createElement('evo-model-viewer');
        full.setAttribute('data-model-url', item.dataset.modelUrl);full.setAttribute('data-poster', item.dataset.poster);
        full.tabIndex = 0;full.setAttribute('role', 'img');full.setAttribute('aria-label', item.dataset.name + ' — ' + section.dataset.zoomLabel);
        dialogModel.replaceChildren(full);dialog.showModal();playback();
        requestAnimationFrame(() => full.focus({preventScroll:true}));
      });
    });
    const close = () => dialog.close();
    listen(section.querySelector('[data-form-close]'), 'click', close);
    listen(section.querySelector('[data-form-reset]'), 'click', () => dialogModel.querySelector('evo-model-viewer')?.resetView?.());
    listen(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    listen(dialog, 'close', () => {dialogModel.replaceChildren();opener?.focus({preventScroll:true});opener = null;});
    listen(section.querySelector('[data-forms-more]'), 'click', event => {
      const expanded = section.classList.toggle('is-expanded');
      event.currentTarget.setAttribute('aria-expanded', String(expanded));event.currentTarget.textContent = expanded ? event.currentTarget.dataset.collapse : event.currentTarget.dataset.expand;
    });
    listen(reduce, 'change', () => {if (reduce.matches) {manualPause = true;playback();}});
    section.dataset.ready = 'true';playback();
    cleanup.set(section, () => {controller.abort();if (dialog.open) dialog.close();dialogModel.replaceChildren();viewers.forEach(viewer => viewer.pause?.());delete section.dataset.ready;cleanup.delete(section);});
  });
  const ready = () => {initialize(document);initializeCollection();};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});else ready();
  document.addEventListener('shopify:section:load', ready);
  document.addEventListener('shopify:section:unload', event => {const removed=galleries(event.target);removed.forEach(section => cleanup.get(section)?.());if(removed.length)document.querySelectorAll('[data-collection-view]').forEach(root=>collectionCleanup.get(root)?.dispose());event.target.querySelectorAll('[data-collection-view]').forEach(root=>collectionCleanup.get(root)?.dispose());});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.evoMotionLoaded) return;
  window.evoMotionLoaded = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const time = s => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
  const setups = new WeakMap();
  function cinema(root) {
    if (setups.has(root)) return;
    const video = root.querySelector('video');
    if (!video) return;
    const controller = new AbortController(), signal = controller.signal;
    const controls = root.querySelector('[data-film-controls]'), toggle = root.querySelector('[data-film-toggle]'), start = root.querySelector('[data-film-start]');
    const seek = root.querySelector('[data-film-seek]'), clock = root.querySelector('[data-film-time]');
    const chapters = [...root.querySelectorAll('[data-film-chapter]')], copies = [...root.querySelectorAll('[data-film-copy]')];
    let active = -1, manualPause = false, inView = false, hasStarted = false;
    const update = () => {
      const duration = Number.isFinite(video.duration) ? video.duration : 44;
      seek.max = String(duration); seek.value = String(video.currentTime);
      clock.textContent = `${time(video.currentTime)} / ${time(duration)}`;
      let index = 0;
      chapters.forEach((chapter, i) => { if (video.currentTime >= Number(chapter.dataset.filmChapter)) index = i; });
      if (active !== index) { active = index; chapters.forEach((chapter, i) => chapter.setAttribute('aria-pressed', String(i === index))); copies.forEach((copy, i) => { copy.hidden = i !== index; }); }
      toggle.textContent = video.paused ? root.dataset.playLabel : root.dataset.pauseLabel;
      start.hidden = hasStarted || !video.paused;
    };
    const play = () => { if (video.ended) video.currentTime = 0; video.play().then(() => { hasStarted = true; update(); }).catch(update); };
    const showFilm = () => root.querySelector('.evo-cinema__screen').scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'center'});
    const changePlayback = () => { manualPause = !video.paused; if (video.paused) { showFilm(); play(); } else video.pause(); };
    controls.hidden = false; start.hidden = false; video.controls = false;
    toggle.addEventListener('click', changePlayback, {signal}); start.addEventListener('click', changePlayback, {signal});
    root.querySelector('[data-film-restart]').addEventListener('click', () => { manualPause = false; video.currentTime = 0; showFilm(); play(); }, {signal});
    chapters.forEach(chapter => chapter.addEventListener('click', () => {
      manualPause = false;
      const target = Number(chapter.dataset.filmChapter) + .75;
      const jump = () => { video.currentTime = target; hasStarted = true; update(); showFilm(); play(); };
      if (video.readyState >= 1) jump();
      else { video.addEventListener('loadedmetadata', jump, {once: true, signal}); video.load(); }
    }, {signal}));
    seek.addEventListener('input', () => { manualPause = true; video.pause(); video.currentTime = Number(seek.value); hasStarted = true; update(); }, {signal});
    root.querySelector('[data-film-fullscreen]').addEventListener('click', () => { if (video.requestFullscreen) video.requestFullscreen().catch(() => {}); else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); }, {signal});
    video.addEventListener('fullscreenchange', () => { video.controls = document.fullscreenElement === video; }, {signal});
    ['loadedmetadata', 'timeupdate', 'play', 'pause', 'ended'].forEach(event => video.addEventListener(event, update, {signal}));
    video.addEventListener('error', () => { root.querySelector('[data-film-error]').hidden = false; video.controls = true; controls.hidden = true; start.hidden = true; copies.forEach(copy => { copy.hidden = false; }); }, {signal});
    const permitted = () => !reduced.matches && !navigator.connection?.saveData && !document.hidden && !manualPause && !video.ended;
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; if (inView && permitted()) play(); else if (!inView) video.pause(); }, {threshold: .45});
    observer.observe(video);
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (inView && permitted()) play(); }, {signal});
    reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); }, {signal});
    update(); setups.set(root, () => { video.pause(); observer.disconnect(); controller.abort(); });
  }
  function motion(root) {
    if (setups.has(root)) return;
    const button = root.querySelector('[data-motion-toggle]');
    let paused = reduced.matches;
    const update = () => { root.classList.toggle('is-paused', paused); button.hidden = reduced.matches; button.textContent = paused ? root.dataset.playLabel : root.dataset.pauseLabel; button.setAttribute('aria-pressed', String(!paused)); };
    const click = () => { paused = !paused; update(); };
    const onReduced = () => { paused = reduced.matches; update(); };
    button.addEventListener('click', click); reduced.addEventListener('change', onReduced);
    const observer = new IntersectionObserver(entries => root.classList.toggle('is-outside', !entries[0].isIntersecting)); observer.observe(root);
    update(); setups.set(root, () => { observer.disconnect(); button.removeEventListener('click', click); reduced.removeEventListener('change', onReduced); });
  }
  function init(scope = document) { scope.querySelectorAll('[data-cinema]').forEach(cinema); scope.querySelectorAll('[data-motion-study]').forEach(motion); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-cinema],[data-motion-study]').forEach(root => { setups.get(root)?.(); setups.delete(root); }); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-nature-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (window.EloviumNatureLandscape) return;

  const KEYS = ['waterFlow', 'ripple', 'wind', 'foliage', 'spiral', 'lift', 'pulse', 'spread'];
  const MOTIFS = ['waves', 'branches', 'unfurling-spiral', 'budding', 'balanced-eddies', 'folded-ripples', 'rising-mist', 'drifting-petals', 'connected-currents', 'interlocking-rings', 'braided-current', 'inward-swirl', 'leaf-veins', 'passing-gust', 'opening-rosette', 'concentric-ring'];
  const DEFAULTS = { waterFlow: .45, ripple: .35, wind: .3, foliage: .45, spiral: .15, lift: .25, pulse: .2, spread: .4, direction: 1, tint: '#91b4ac', motif: 'waves' };
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const color = value => {
    const match = /^#?([0-9a-f]{6})$/i.exec(String(value));
    const hex = match ? match[1] : '91b4ac';
    return [0, 2, 4].map(index => parseInt(hex.slice(index, index + 2), 16) / 255);
  };

  const vertexSource = `
    attribute vec2 aPosition;
    varying vec2 vUv;
    void main() { vUv = aPosition * .5 + .5; gl_Position = vec4(aPosition, 0., 1.); }
  `;

  const fragmentSource = `
    precision highp float;
    varying vec2 vUv;
    uniform vec2 uResolution;
    uniform float uTime, uActivity, uDirection;
    uniform vec4 uWater, uAir;
    uniform vec3 uTint;
    uniform vec2 uMotifs;
    uniform float uMotifMix, uTransition;

    float hash(float n) { return fract(sin(n * 127.1 + 19.19) * 43758.5453); }
    float hash2(vec2 p) { return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453); }
    float noise(vec2 p) {
      vec2 i = floor(p), f = fract(p); f = f * f * (3. - 2. * f);
      return mix(mix(hash2(i), hash2(i + vec2(1., 0.)), f.x),
        mix(hash2(i + vec2(0., 1.)), hash2(i + vec2(1.)), f.x), f.y);
    }
    float fbm(vec2 p) {
      float n = .54 * noise(p); p = p * 2.07 + vec2(2.7, 7.1);
      n += .27 * noise(p); p = p * 2.03 + vec2(4.9, 1.7);
      return n + .135 * noise(p);
    }
    float pineLine(float x, float ridge, float density, float seed) {
      float cell = floor(x * density), local = fract(x * density) - .5;
      float h = .006 + hash(cell + seed) * .014;
      float silhouette = (1. - abs(local) * 2.) * h;
      silhouette *= .78 + .22 * sin(abs(local) * 31.);
      return ridge + max(0., silhouette);
    }
    vec3 hills(vec2 p, vec3 sky) {
      if (p.y > .64) return sky;
      float distant = .512 + .038 * sin(p.x * 6.5 + .7) + .043 * fbm(vec2(p.x * 7., 6.2));
      float middle = .474 + .032 * sin(p.x * 8.5 - .9) + .045 * fbm(vec2(p.x * 10., 17.));
      float near = .449 + .082 * pow(abs(p.x - .5) * 2., 1.8) + .012 * fbm(vec2(p.x * 24., 41.));
      distant = pineLine(p.x, distant, 270., 19.);
      middle = pineLine(p.x, middle, 210., 43.);
      near = pineLine(p.x, near, 160., 71.);
      vec3 c = mix(sky, vec3(.16, .208, .201), 1. - smoothstep(distant - .001, distant + .0015, p.y));
      c = mix(c, vec3(.093, .145, .132), 1. - smoothstep(middle - .001, middle + .0015, p.y));
      float texture = noise(vec2(p.x * 180., p.y * 95.)) * .015;
      vec3 forest = vec3(.041, .082, .065) + texture + uTint * .009;
      c = mix(c, forest, 1. - smoothstep(near - .001, near + .001, p.y));
      float fog = exp(-abs(p.y - .447) * 85.) * .13;
      return c + vec3(.36, .43, .40) * fog;
    }
    float rockMask(vec2 p, vec2 center, vec2 radius, float seed) {
      vec2 q = (p - center) / radius;
      float rim = .91 + .06 * sin(atan(q.y, q.x) * 5. + seed) + .04 * noise(q * 6. + seed);
      return 1. - smoothstep(rim - .015, rim + .015, length(q));
    }
    vec3 rocks(vec2 p, vec3 c, float side) {
      vec2 q = vec2(side < 0. ? p.x : 1. - p.x, p.y);
      if (q.x > .23 || q.y > .22) return c;
      float stone = rockMask(q, vec2(.042, .095), vec2(.115, .112), side * 4.);
      float small = rockMask(q, vec2(.12, .025), vec2(.085, .065), 9. + side);
      vec3 rock = vec3(.033, .048, .044);
      float facet = noise(vec2(q.x * 53., q.y * 29.)) * .035;
      float light = smoothstep(.06, .19, q.y) * .052;
      rock += facet + vec3(.75, .90, .87) * light;
      c = mix(c, rock, stone);
      return mix(c, rock * .67, small);
    }
    vec3 grasses(vec2 p, vec3 c, float side) {
      vec2 q = vec2(side < 0. ? p.x : 1. - p.x, p.y);
      if (q.x > .255 || q.y > .40) return c;
      float foliage = uAir.x;
      for (int i = 0; i < 17; i++) {
        float n = float(i), seed = hash(n + (side < 0. ? 13. : 44.));
        float base = .008 + hash(n + 27.) * .135;
        float height = .12 + seed * .205;
        float y = q.y / height;
        float bend = (.009 + seed * .037) * y * y;
        float sway = sin(uTime * (.53 + uWater.z * .45) + seed * 8. + y * 1.2);
        sway += sin(uTime * .28 + n * .77) * .4;
        bend += sway * y * y * (.0025 + uWater.z * .009 + uActivity * .006);
        float x = base + bend * (.9 + foliage * .35);
        float width = (.0012 + seed * .0015) * max(.0, 1. - y) + .00018;
        float blade = (1. - smoothstep(width, width + .0007, abs(q.x - x))) * step(0., y) * (1. - step(1., y));
        blade *= .55 + foliage * .45;
        vec3 leaf = mix(vec3(.025, .057, .043), vec3(.117, .163, .113), seed);
        leaf += vec3(.035, .041, .025) * max(0., sway) * y;
        c = mix(c, leaf, blade);
        // A few seed heads make these shoreline reeds rather than abstract lines.
        if (i < 6) {
          float headY = .83 + seed * .08;
          float hx = base + (.009 + seed * .037) * headY * headY;
          hx += sway * headY * headY * (.0025 + uWater.z * .009 + uActivity * .006);
          float head = 1. - smoothstep(.7, 1., length((q - vec2(hx, headY * height)) / vec2(.0018, .017)));
          c = mix(c, vec3(.115, .132, .088), head * .85);
        }
      }
      return c;
    }
    float segment(vec2 p, vec2 a, vec2 b, float width) {
      vec2 pa = p - a, ba = b - a;
      float h = clamp(dot(pa, ba) / max(dot(ba, ba), .00001), 0., 1.);
      return 1. - smoothstep(width, width + .0009, length(pa - ba * h));
    }
    mat2 rotation(float angle) { float s = sin(angle), c = cos(angle); return mat2(c, -s, s, c); }
    float leafShape(vec2 q) {
      float width = .52 * pow(max(0., 1. - q.y * q.y), .75);
      return (1. - smoothstep(width - .045, width + .045, abs(q.x))) * (1. - smoothstep(.94, 1., abs(q.y)));
    }
    float stemX(float y, float side, float braid) {
      float sway = sin(uTime * .43 + y * 6. + side) * (.009 + uWater.z * .016) + uActivity * .007;
      return .021 + y * .20 + sway * y * y + braid * sin(y * 23. + side * 2.) * .012;
    }
    vec3 branches(vec2 p, vec3 c, float side, float braid, float amount) {
      vec2 q = vec2(side < 0. ? p.x : 1. - p.x, p.y);
      if (q.x > .32 || q.y > .66) return c;
      float y = (q.y - .07) / .54;
      float center = stemX(y, side, braid);
      float trunk = (1. - smoothstep(.001 + (1. - y) * .0031, .002 + (1. - y) * .0031, abs(q.x - center))) * step(0., y) * (1. - step(1., y));
      float shape = trunk, rim = trunk * smoothstep(center - .004, center + .003, q.x);
      for (int i = 0; i < 6; i++) {
        float n = float(i), t = .23 + n * .113;
        float seed = hash(n + (side < 0. ? 42. : 81.));
        vec2 a = vec2(stemX(t, side, braid), .07 + t * .54);
        float lean = sin(uTime * .43 + t * 6. + side) * .009 + uActivity * .006;
        vec2 b = a + vec2(.035 + seed * .049, .035 + seed * .052);
        b.x += lean + braid * sin(n * 2.1 + uTime * .18) * .022;
        vec2 mid = mix(a, b, .51) + vec2(-.006, .009);
        float twig = max(segment(q, a, mid, .0013), segment(q, mid, b, .00065));
        vec2 split = mix(a, b, .58);
        vec2 fork = split + vec2(-.016 + braid * .035, .039 + seed * .025);
        twig = max(twig, segment(q, split, fork, .00055));
        vec2 tip = b + vec2(.010, .019);
        float leaf = leafShape(rotation(-.48 + lean * 7.) * (q - tip) / vec2(.020, .027));
        leaf *= .35 + uAir.x * .5;
        shape = max(shape, max(twig, leaf));
        rim = max(rim, twig * .5 + leaf * .2);
      }
      vec3 branchColor = vec3(.024, .048, .034) + uTint * .012 + rim * vec3(.035, .043, .024);
      return mix(c, branchColor, shape * amount);
    }
    float eddy(vec2 q, float direction, float phase, float tightness) {
      float r = length(q), angle = atan(q.y, q.x);
      float curl = pow(max(0., .5 + .5 * cos(angle * 2. - r * tightness + direction * uTime * .17 + phase)), 18.);
      return curl * smoothstep(.015, .045, r) * (1. - smoothstep(.11, .24, r));
    }
    vec3 motif(vec2 p, vec3 c, float id, float amount) {
      if (amount < .002 || p.y > .68) return c;
      bool hasBranches = (id > .5 && id < 1.5) || (id > 7.5 && id < 8.5) || (id > 11.5 && id < 12.5);
      bool hasMist = id > 5.5 && id < 6.5;
      if (p.y > .44 && !hasMist && (!hasBranches || (p.x > .32 && p.x < .68))) return c;
      float water = (1. - smoothstep(.395, .44, p.y)) * smoothstep(.015, .09, p.y);
      vec2 lake = vec2(p.x, p.y * 2.5);
      float light = 0., shadow = 0.;
      float breeze = sin(uTime * .42) * .5 + .5;
      float opening = .63 + .18 * sin(uTime * .28) + uTransition * .16;
      if (id < .5) {
        float wave = sin(p.y * 99. + sin(p.x * 8.5 + uTime * .16) * 2.2 - uTime * .33);
        light = pow(max(0., wave), 12.) * .036 * exp(-pow((p.x - .53) * 2.3, 2.));
      } else if (id < 1.5) {
        c = branches(p, c, -1., 0., amount);
        c = branches(p, c, 1., 0., amount * .63);
        shadow = .035 * (1. - smoothstep(.12, .29, min(p.x, 1. - p.x))) * (.5 + .5 * sin(p.y * 160. + p.x * 25. + uTime * .2));
      } else if (id < 2.5) {
        vec2 q = lake - vec2(.54, .61);
        q *= rotation(uTime * .023);
        light = eddy(q, -1., opening * 2., 24. - opening * 5.) * .067;
      } else if (id < 3.5) {
        for (int i = 0; i < 5; i++) {
          float n = float(i), s = hash(n + 5.);
          vec2 center = vec2(i < 3 ? .20 + n * .046 : .75 + (n - 3.) * .055, .13 + s * .15);
          vec2 q = rotation(s * 1.4 - .7) * (p - center);
          float size = .025 * (opening + s * .25);
          float bud = leafShape(q / vec2(size, size * .95));
          float seam = 1. - smoothstep(.0005, .002, abs(q.x));
          light += bud * (.035 + seam * .024) * (1. - abs(q.y) / max(.001, size));
          light += exp(-dot(q, q) / .0013) * .009;
        }
      } else if (id < 4.5) {
        float space = .115 + sin(uTime * .16) * .019;
        light = (eddy(lake - vec2(.5 - space, .60), 1., .1, 29.) + eddy(lake - vec2(.5 + space, .60), -1., 1.4, 29.)) * .046;
      } else if (id < 5.5) {
        float fold = sin(p.y * 164. + sin(p.x * 17. + uTime * .16) * (2. + opening * 3.));
        light = pow(max(0., fold), 8.) * .042 * exp(-pow((p.x - .52) * 3., 2.));
        shadow = pow(max(0., -fold), 6.) * .012;
      } else if (id < 6.5) {
        float height = smoothstep(.27, .39, p.y) * (1. - smoothstep(.50, .67, p.y));
        float curve = .78 + sin(p.y * 17. - uTime * .23) * (.012 + (p.y - .25) * .04);
        float mist = exp(-pow((p.x - curve) / (.011 + (p.y - .2) * .022), 2.)) * height;
        mist *= .7 + .3 * noise(vec2(p.x * 18., p.y * 22. - uTime * .10));
        return c + uTint * mist * amount * .068;
      } else if (id < 7.5) {
        for (int i = 0; i < 7; i++) {
          float n = float(i), seed = hash(n + 35.);
          vec2 center = vec2(.19 + seed * .64 + sin(uTime * .18 + n) * .018, .14 + hash(n + 64.) * .23 + cos(uTime * .14 + n) * .007);
          vec2 q = rotation(-.75 + sin(uTime * .19 + n) * .23 + seed * 1.1) * (p - center);
          q /= vec2(.032 + seed * .020, .031 + seed * .023);
          float leaf = leafShape(q);
          shadow += leaf * .043;
          light += leaf * (1. - smoothstep(.015, .048, abs(q.x))) * .026;
        }
      } else if (id < 8.5) {
        c = branches(p, c, -1., 1., amount);
        c = branches(p, c, 1., 1., amount);
        for (int i = 0; i < 4; i++) {
          float n = float(i), branch = .22 + sin(p.x * 15. + n * 1.5 + uTime * .12) * .033;
          branch += sin(p.x * 7. + n * 3.14) * .041;
          light += (1. - smoothstep(.0012, .0032, abs(p.y - branch))) * .025;
        }
        light *= smoothstep(.16, .28, p.x) * (1. - smoothstep(.73, .84, p.x));
      } else if (id < 9.5) {
        float left = length((p - vec2(.446, .245)) * vec2(1., 2.4));
        float right = length((p - vec2(.568, .245)) * vec2(1., 2.4));
        float radius = .105 + sin(uTime * .31) * .005;
        float rings = max(1. - smoothstep(.0015, .004, abs(left - radius)), 1. - smoothstep(.0015, .004, abs(right - radius)));
        light = rings * .070 * (.7 + .3 * sin(p.x * 73. + uTime * .15));
      } else if (id < 10.5) {
        for (int i = 0; i < 3; i++) {
          float n = float(i), strand = .24 + sin(p.x * 24. + n * 2.094 - uTime * .35) * .039;
          light += (1. - smoothstep(.0014, .004, abs(p.y - strand))) * (.03 + .022 * sin(p.x * 24. + n * 2.094 - uTime * .35));
        }
        light *= smoothstep(.18, .31, p.x) * (1. - smoothstep(.70, .84, p.x));
      } else if (id < 11.5) {
        vec2 q = lake - vec2(.52, .61);
        light = eddy(q, 1., 0., 53.) * .060;
        shadow = exp(-dot(q, q) * 210.) * .014;
      } else if (id < 12.5) {
        c = branches(p, c, -1., 0., amount * .6);
        if (p.y > .43 || p.x > .88 || (p.x > .35 && p.x < .68)) return c;
        for (int i = 0; i < 3; i++) {
          float n = float(i);
          vec2 center = vec2(i < 2 ? .19 + n * .07 : .78, .23 + n * .055);
          vec2 q = rotation(-.70 + n * .73 + sin(uTime * .32 + n) * .09) * (p - center);
          q /= vec2(.060, .071);
          float leaf = leafShape(q);
          float midrib = 1. - smoothstep(.013, .035, abs(q.x));
          float veins = pow(max(0., cos((q.y - abs(q.x) * 1.35) * 20.)), 18.);
          shadow += leaf * .036;
          light += leaf * (.018 * veins + .037 * midrib);
        }
      } else if (id < 13.5) {
        float gust = sin(p.x * 5.1 - p.y * 9. + uTime * .47) * .5 + .5;
        float sweep = exp(-pow((p.y - .275 - sin(p.x * 5. - uTime * .18) * .061) * 26., 2.));
        float shimmer = pow(max(0., sin(p.y * 190. + p.x * 11. + uTime * .75)), 15.);
        light = sweep * shimmer * (.022 + gust * .048);
      } else if (id < 14.5) {
        vec2 q = (p - vec2(.50, .24)) * vec2(1., 2.45);
        float radius = length(q), angle = atan(q.y, q.x) + uTime * .018;
        float petals = .067 + .038 * (.5 + .5 * cos(angle * 7.)) * opening;
        float outline = 1. - smoothstep(.003, .009, abs(radius - petals));
        float core = exp(-radius * radius * 920.) * .021;
        light = outline * .052 + core;
        light += exp(-pow((radius - petals * .62) * 105., 2.)) * .013;
      } else {
        vec2 q = (p - vec2(.515, .25)) * vec2(1., 2.45);
        float radius = length(q), breath = sin(uTime * .25) * .008;
        float ring = 1. - smoothstep(.0018, .0044, abs(radius - .112 - breath));
        float outer = 1. - smoothstep(.001, .0034, abs(radius - .166 - breath * 1.4));
        float inner = 1. - smoothstep(.0012, .0033, abs(radius - .064 - breath * .6));
        light = ring * .064 + outer * .023 + inner * .033;
      }
      return c + uTint * light * water * amount - vec3(.7, .88, .74) * shadow * water * amount;
    }
    void main() {
      vec2 p = vUv;
      float time = uTime;
      float horizon = .443;
      float skyHeight = smoothstep(horizon, 1., p.y);
      vec3 sky = mix(vec3(.24, .29, .275), vec3(.06, .095, .10), skyHeight);
      float clearing = exp(-pow((p.x - .61) * 2.9, 2.) - pow((p.y - .63) * 4., 2.));
      sky += vec3(.083, .086, .07) * clearing;
      float cloud = fbm(vec2(p.x * 3.1 + time * .003 * uDirection, p.y * 5.4 + time * .002 * uAir.z));
      sky += (cloud - .45) * .035;
      sky = mix(sky, sky * (.75 + uTint * .42), .20);
      vec3 c = sky;

      if (p.y >= horizon) c = hills(p, sky);

      if (p.y < horizon) {
        float depth = clamp((horizon - p.y) / horizon, 0., 1.);
        float perspective = 1. / (.18 + depth * 1.9);
        float flow = time * (.018 + uWater.x * .046) * uDirection;
        vec2 w = vec2((p.x - .5) * (3.5 + perspective), perspective * 1.8);
        float eddy = atan(w.y - 2.2, w.x + .28) * uAir.y * .18;
        float waterNoise = fbm(vec2(w.x * 3.1 + flow + eddy, w.y * 9.8 + flow * .4));
        float fine = noise(vec2(w.x * 20. + time * .045, w.y * 58. + flow));
        float wave = sin(w.y * 37. + waterNoise * 5.4 + flow * 8. + eddy * 3.);
        float wave2 = sin(w.y * 77. + w.x * 2.3 + waterNoise * 7. - flow * 5.);
        float strength = .4 + uWater.y * .65 + uActivity * .6;
        float distortion = (waterNoise - .43) * .011 * strength * depth;
        distortion += wave * .0007 * depth * strength;
        vec2 reflected = vec2(p.x + distortion * 2.8, horizon + (horizon - p.y) * .75 + distortion);
        c = hills(reflected, sky);
        c = mix(c * vec3(.72, .84, .80), vec3(.025, .068, .063), .29 + depth * .31);
        c += uTint * .018 * depth;
        float band = pow(max(0., wave * .5 + .5), 16.) * (.35 + fine * .65);
        float threads = pow(max(0., wave2 * .5 + .5), 22.);
        float opening = exp(-pow((p.x - .60 + distortion * 3.) * (2.6 + uAir.w), 2.));
        float silver = band * (.018 + depth * .050) + threads * .012 * depth;
        c += vec3(.57, .69, .65) * silver * (.35 + opening * 1.8) * strength;
        c -= (waterNoise - .45) * .024;
        // Broad, low contrast wake: the profile change travels across real water.
        vec2 wake = vec2((p.x - (.46 + uAir.w * .08)) * 1.3, (p.y - .25) * 3.0);
        float radius = length(wake);
        float rings = sin(radius * (32. + uWater.w * 20.) - time * (.30 + uWater.w * .50));
        float wakeLight = pow(max(0., rings), 12.) * exp(-radius * 5.);
        c += uTint * wakeLight * (.003 + uWater.w * .012 + uActivity * .010) * (1. - smoothstep(.36, .43, p.y));
        float mist = exp(-pow((p.y - .431 + (cloud - .4) * .008) * 105., 2.));
        c += vec3(.24, .29, .27) * mist * (.11 + uAir.z * .13);
      }
      if (p.y < .68) {
        if (abs(uMotifs.x - uMotifs.y) < .1) {
          c = motif(p, c, uMotifs.y, 1.);
        } else {
          if (uMotifMix < .998) c = motif(p, c, uMotifs.x, 1. - uMotifMix);
          if (uMotifMix > .002) c = motif(p, c, uMotifs.y, uMotifMix);
        }
      }
      if (p.y < .40) {
        if (p.x < .255) { c = rocks(p, c, -1.); c = grasses(p, c, -1.); }
        else if (p.x > .745) { c = rocks(p, c, 1.); c = grasses(p, c, 1.); }
      }
      float vignette = smoothstep(.25, .78, length((p - vec2(.5, .48)) * vec2(1., .8)));
      c *= 1. - vignette * .37;
      // Fine sensor-like grain prevents banding in the soft dusk sky.
      c += (hash2(gl_FragCoord.xy) - .5) / 650.;
      gl_FragColor = vec4(max(c, vec3(0.)), 1.);
    }
  `;

  window.EloviumNatureLandscape = class EloviumNatureLandscape {
    constructor(canvas) {
      if (!canvas || typeof canvas.getContext !== 'function') throw new TypeError('A canvas is required.');
      this.canvas = canvas;
      this.destroyed = false;
      this.paused = false;
      this.inView = true;
      this.time = 0;
      this.lastFrame = 0;
      this.frame = 0;
      this.frameInterval = 1000 / 24;
      this.progress = 1;
      this.activity = 0;
      this.current = this.normalize(DEFAULTS);
      this.from = { ...this.current, tint: [...this.current.tint] };
      this.target = { ...this.current, tint: [...this.current.tint] };
      this.previousMotif = this.current.motif;
      this.motifMix = 1;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = () => {
        if (this.reducedMotion.matches) {
          this.current = { ...this.target, tint: [...this.target.tint] };
          this.progress = 1;
          this.activity = 0;
          this.motifMix = 1;
        }
        this.draw();
        this.schedule();
      };
      this.onVisibility = () => { this.lastFrame = 0; this.schedule(); };
      this.onContextLost = event => { event.preventDefault(); this.contextLost = true; this.cancel(); };
      this.onContextRestored = () => {
        this.contextLost = false;
        try { this.initializeGL(); this.resize(); this.schedule(); } catch (_) { this.contextLost = true; }
      };
      this.tick = timestamp => {
        this.frame = 0;
        if (!this.canAnimate()) { this.lastFrame = 0; return; }
        if (this.lastFrame && timestamp - this.lastFrame < this.frameInterval) { this.schedule(); return; }
        const elapsed = this.lastFrame ? (timestamp - this.lastFrame) / 1000 : 0;
        const delta = Math.min(.067, elapsed);
        this.lastFrame = timestamp;
        this.time += delta;
        if (this.progress < 1) {
          this.progress = Math.min(1, this.progress + elapsed / 1.3);
          const eased = this.progress * this.progress * (3 - 2 * this.progress);
          this.motifMix = eased;
          for (const key of [...KEYS, 'direction']) this.current[key] = this.from[key] + (this.target[key] - this.from[key]) * eased;
          this.current.tint = this.from.tint.map((value, index) => value + (this.target.tint[index] - value) * eased);
          if (this.progress >= 1) this.current.motif = this.target.motif;
          this.activity = Math.sin(this.progress * Math.PI) * .72;
        } else this.activity = Math.max(0, this.activity - delta * .55);
        this.draw();
        this.schedule();
      };
      this.gl = canvas.getContext('webgl', { alpha: false, antialias: false, depth: false, stencil: false, preserveDrawingBuffer: false, powerPreference: 'low-power' });
      if (this.gl) {
        try { this.initializeGL(); } catch (error) {
          // A context cannot change types: replace only this failed drawing surface.
          const fallback = canvas.cloneNode(false);
          canvas.replaceWith(fallback);
          this.canvas = fallback;
          this.releaseGL();
          this.gl = null;
          this.context = fallback.getContext('2d', { alpha: false });
        }
      } else this.context = canvas.getContext('2d', { alpha: false });
      this.canvas.addEventListener('webglcontextlost', this.onContextLost);
      this.canvas.addEventListener('webglcontextrestored', this.onContextRestored);
      if (this.reducedMotion.addEventListener) this.reducedMotion.addEventListener('change', this.onMotion);
      else this.reducedMotion.addListener(this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(() => this.resize()) : null;
      if (this.resizeObserver) this.resizeObserver.observe(this.canvas);
      this.onResize = () => this.resize();
      window.addEventListener('resize', this.onResize, { passive: true });
      this.intersectionObserver = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.lastFrame = 0;
        this.schedule();
      }, { rootMargin: '100px' }) : null;
      if (this.intersectionObserver) this.intersectionObserver.observe(this.canvas);
      this.resize();
      this.schedule();
    }

    normalize(parameters) {
      const result = {};
      for (const key of KEYS) result[key] = clamp(Number.isFinite(Number(parameters[key])) ? Number(parameters[key]) : DEFAULTS[key], 0, 1);
      result.direction = Number(parameters.direction) < 0 ? -1 : 1;
      result.tint = Array.isArray(parameters.tint) ? parameters.tint.slice(0, 3) : color(parameters.tint || DEFAULTS.tint);
      result.motif = MOTIFS.includes(parameters.motif) ? parameters.motif : DEFAULTS.motif;
      return result;
    }

    initializeGL() {
      const gl = this.gl;
      const compile = (type, source) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
          const message = gl.getShaderInfoLog(shader);
          gl.deleteShader(shader);
          throw new Error(message || 'Landscape shader unavailable.');
        }
        return shader;
      };
      const vertex = compile(gl.VERTEX_SHADER, vertexSource);
      let fragment;
      try {
        const precision = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
        fragment = compile(gl.FRAGMENT_SHADER, precision && precision.precision ? fragmentSource : fragmentSource.replace('precision highp float;', 'precision mediump float;'));
      } catch (error) { gl.deleteShader(vertex); throw error; }
      this.program = gl.createProgram();
      gl.attachShader(this.program, vertex);
      gl.attachShader(this.program, fragment);
      gl.linkProgram(this.program);
      gl.deleteShader(vertex);
      gl.deleteShader(fragment);
      if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(this.program));
      gl.useProgram(this.program);
      this.buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
      const position = gl.getAttribLocation(this.program, 'aPosition');
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
      this.uniforms = {};
      for (const name of ['uResolution', 'uTime', 'uActivity', 'uDirection', 'uWater', 'uAir', 'uTint', 'uMotifs', 'uMotifMix', 'uTransition']) this.uniforms[name] = gl.getUniformLocation(this.program, name);
      gl.disable(gl.DEPTH_TEST);
    }

    setProfile(parameters = {}) {
      if (this.destroyed) return;
      const merged = { ...this.target, ...parameters };
      this.previousMotif = this.motifMix >= .5 ? this.target.motif : this.previousMotif;
      this.from = { ...this.current, tint: [...this.current.tint] };
      this.target = this.normalize(merged);
      this.progress = 0;
      this.motifMix = 0;
      this.activity = 0;
      if (this.reducedMotion.matches || this.paused || !this.gl) {
        this.current = { ...this.target, tint: [...this.target.tint] };
        this.progress = 1;
        this.motifMix = 1;
      }
      this.draw();
      this.schedule();
    }

    setPaused(value) {
      this.paused = Boolean(value);
      this.lastFrame = 0;
      this.schedule();
    }

    resize() {
      if (this.destroyed) return;
      const rect = this.canvas.getBoundingClientRect();
      const compact = rect.width <= 640;
      const dpr = Math.min(window.devicePixelRatio || 1, compact ? 1 : 1.25);
      // Keep the atmosphere soft and affordable; the separate jewellery stays sharp.
      const pixelBudget = compact ? 240000 : 480000;
      const scale = Math.min(dpr, 1280 / Math.max(1, rect.width), Math.sqrt(pixelBudget / Math.max(1, rect.width * rect.height)));
      this.frameInterval = 1000 / (compact ? 20 : 24);
      const width = Math.max(1, Math.round(rect.width * scale));
      const height = Math.max(1, Math.round(rect.height * scale));
      if (this.canvas.width !== width || this.canvas.height !== height) {
        this.canvas.width = width;
        this.canvas.height = height;
      }
      if (this.gl && !this.contextLost) this.gl.viewport(0, 0, width, height);
      this.draw();
    }

    canAnimate() {
      return !this.destroyed && !this.contextLost && Boolean(this.gl) && !this.paused && !this.reducedMotion.matches && !document.hidden && this.inView;
    }

    cancel() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    schedule() {
      if (!this.canAnimate()) { this.cancel(); return; }
      if (!this.frame) this.frame = requestAnimationFrame(this.tick);
    }

    draw() {
      if (this.destroyed || this.contextLost) return;
      if (!this.gl) { this.drawFallback(); return; }
      const gl = this.gl, u = this.uniforms, p = this.current;
      gl.useProgram(this.program);
      gl.uniform2f(u.uResolution, this.canvas.width, this.canvas.height);
      gl.uniform1f(u.uTime, this.time);
      gl.uniform1f(u.uActivity, this.activity);
      gl.uniform1f(u.uDirection, p.direction);
      gl.uniform4f(u.uWater, p.waterFlow, p.ripple, p.wind, p.pulse);
      gl.uniform4f(u.uAir, p.foliage, p.spiral, p.lift, p.spread);
      gl.uniform3fv(u.uTint, p.tint);
      gl.uniform2f(u.uMotifs, MOTIFS.indexOf(this.previousMotif), MOTIFS.indexOf(this.target.motif));
      gl.uniform1f(u.uMotifMix, this.motifMix);
      gl.uniform1f(u.uTransition, this.progress);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
    }

    drawFallback() {
      const ctx = this.context;
      if (!ctx) return;
      const w = this.canvas.width, h = this.canvas.height, p = this.current;
      const rgb = p.tint.map(value => Math.round(value * 255)).join(',');
      const sky = ctx.createLinearGradient(0, 0, 0, h * .58);
      sky.addColorStop(0, '#111c20'); sky.addColorStop(1, '#46564f');
      ctx.fillStyle = sky; ctx.fillRect(0, 0, w, h);
      const ridges = [[], [], []];
      const ridgeColors = ['#293c38', '#1b3028', '#10251e'];
      for (let layer = 0; layer < 3; layer++) {
        for (let x = 0; x <= 120; x++) {
          const t = x / 120;
          ridges[layer].push([t * w, h * (.45 + layer * .035 - Math.sin(t * 6.4 + layer) * .029 - Math.sin(t * 15.7 + layer * 5) * .01)]);
        }
        ctx.beginPath(); ctx.moveTo(0, h * .57);
        ridges[layer].forEach(point => ctx.lineTo(...point));
        ctx.lineTo(w, h * .57); ctx.closePath(); ctx.fillStyle = ridgeColors[layer]; ctx.fill();
        for (let i = 0; i < 119; i++) {
          const [x, y] = ridges[layer][i];
          const tree = h * (.005 + ((i * 37) % 17) / 1700);
          ctx.beginPath(); ctx.moveTo(x, y - tree); ctx.lineTo(x - tree * .33, y + tree * .25); ctx.lineTo(x + tree * .33, y + tree * .25); ctx.fill();
        }
      }
      const water = ctx.createLinearGradient(0, h * .555, 0, h);
      water.addColorStop(0, '#273c35'); water.addColorStop(1, '#071b19');
      ctx.fillStyle = water; ctx.fillRect(0, h * .555, w, h * .445);
      for (let i = 0; i < 140; i++) {
        const depth = i / 140, y = h * (.56 + depth * depth * .44);
        const x = (((i * 73) % 137) / 137) * w;
        ctx.strokeStyle = `rgba(${rgb},${.015 + depth * .032 + p.ripple * .015})`;
        ctx.lineWidth = Math.max(.5, h * .001);
        ctx.beginPath(); ctx.moveTo(x, y); ctx.bezierCurveTo(x + w * .025, y - h * .0015, x + w * .09, y + h * .0015, x + w * (.035 + depth * .10), y); ctx.stroke();
      }
      this.drawFallbackMotif(ctx, w, h);
      for (const side of [-1, 1]) {
        ctx.save(); if (side > 0) { ctx.translate(w, 0); ctx.scale(-1, 1); }
        ctx.fillStyle = '#13221b'; ctx.beginPath(); ctx.ellipse(w * .028, h * .985, w * .13, h * .13, -.3, 0, Math.PI * 2); ctx.fill();
        for (let i = 0; i < 20; i++) {
          const x = w * (.012 + ((i * 43) % 97) / 750), height = h * (.13 + ((i * 37) % 97) / 470);
          ctx.strokeStyle = i % 3 ? '#203727' : '#435740'; ctx.lineWidth = Math.max(.7, w * .0011);
          ctx.beginPath(); ctx.moveTo(x, h); ctx.quadraticCurveTo(x + w * .008, h - height * .62, x + w * (.014 + p.wind * .02), h - height); ctx.stroke();
        }
        ctx.restore();
      }
      const vignette = ctx.createRadialGradient(w * .5, h * .47, h * .2, w * .5, h * .47, Math.max(w, h) * .65);
      vignette.addColorStop(0, 'rgba(0,0,0,0)'); vignette.addColorStop(1, 'rgba(0,0,0,.50)');
      ctx.fillStyle = vignette; ctx.fillRect(0, 0, w, h);
    }

    drawFallbackMotif(ctx, w, h) {
      const p = this.current, id = MOTIFS.indexOf(p.motif);
      const rgb = p.tint.map(value => Math.round(value * 255)).join(',');
      ctx.save(); ctx.scale(w, h);
      ctx.strokeStyle = `rgba(${rgb},.17)`; ctx.fillStyle = `rgba(${rgb},.08)`; ctx.lineWidth = .0012;
      const leaf = (x, y, size, angle, veins = false) => {
        ctx.save(); ctx.translate(x, y); ctx.rotate(angle);
        ctx.beginPath(); ctx.moveTo(0, -size); ctx.bezierCurveTo(size * .8, -size * .55, size * .7, size * .55, 0, size); ctx.bezierCurveTo(-size * .7, size * .55, -size * .8, -size * .55, 0, -size); ctx.fill();
        ctx.beginPath(); ctx.moveTo(0, -size * .9); ctx.lineTo(0, size * .9);
        if (veins) for (let j = -2; j <= 2; j++) {
          const y0 = j * size * .27;
          ctx.moveTo(0, y0); ctx.lineTo(size * .36, y0 - size * .19);
          ctx.moveTo(0, y0); ctx.lineTo(-size * .36, y0 - size * .19);
        }
        ctx.stroke(); ctx.restore();
      };
      if (id === 1 || id === 8 || id === 12) {
        for (const side of [-1, 1]) {
          ctx.save(); if (side > 0) { ctx.translate(1, 0); ctx.scale(-1, 1); }
          ctx.strokeStyle = '#253d2a'; ctx.fillStyle = '#213728'; ctx.lineWidth = .0024;
          ctx.beginPath(); ctx.moveTo(.024, .94); ctx.bezierCurveTo(.095, .77, .137, .51, .205, .36); ctx.stroke();
          for (let i = 0; i < 6; i++) {
            const x = .065 + i * .023, y = .82 - i * .070;
            const endX = x + .057 + (i % 2) * .020, endY = y - .079;
            ctx.lineWidth = .0014;
            ctx.beginPath(); ctx.moveTo(x, y); ctx.quadraticCurveTo(x + .019, y - .035, endX, endY); ctx.moveTo(x + .032, y - .041); ctx.lineTo(x + .014, y - .102); ctx.stroke();
            leaf(endX + .003, endY - .014, .020, -.65);
            if (id === 8) { ctx.beginPath(); ctx.moveTo(x - .013, y + .018); ctx.bezierCurveTo(x + .060, y - .020, x - .015, y - .09, x + .043, y - .12); ctx.stroke(); }
          }
          ctx.restore();
        }
        ctx.strokeStyle = `rgba(${rgb},.17)`; ctx.fillStyle = `rgba(${rgb},.08)`;
      }
      if (id === 7 || id === 12) {
        const count = id === 7 ? 7 : 3;
        ctx.fillStyle = 'rgba(3,18,12,.35)';
        for (let i = 0; i < count; i++) leaf(.20 + ((i * 37) % 67) / 100, .65 + ((i * 31) % 23) / 100, id === 7 ? .030 : .055, -.7 + i * .61, id === 12);
      } else if (id === 9 || id === 15) {
        for (let i = 0; i < (id === 9 ? 2 : 3); i++) {
          ctx.beginPath(); ctx.ellipse(id === 9 ? .446 + i * .122 : .515, .75, id === 9 ? .105 : .064 + i * .05, id === 9 ? .044 : (.064 + i * .05) / 2.45, 0, 0, Math.PI * 2); ctx.stroke();
        }
      } else if (id === 2 || id === 4 || id === 11) {
        for (let e = 0; e < (id === 4 ? 2 : 1); e++) {
          ctx.beginPath();
          for (let i = 0; i <= 180; i++) {
            const angle = i / 180 * Math.PI * (id === 11 ? 5.5 : 3.4), radius = .015 + i / 180 * .15;
            const x = (id === 4 ? .38 + e * .24 : .53) + Math.cos(angle * (e ? -1 : 1)) * radius;
            const y = .75 + Math.sin(angle * (e ? -1 : 1)) * radius / 2.5;
            if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y);
          }
          ctx.stroke();
        }
      } else if (id === 3) {
        for (let i = 0; i < 5; i++) {
          const x = i < 3 ? .20 + i * .046 : .75 + (i - 3) * .055;
          leaf(x, .78 + (i % 3) * .03, .019, (i % 2 ? 1 : -1) * .55);
        }
      } else if (id === 14) {
        ctx.beginPath();
        for (let i = 0; i <= 180; i++) {
          const angle = i / 180 * Math.PI * 2, radius = .067 + .030 * (.5 + .5 * Math.cos(angle * 7));
          const x = .5 + Math.cos(angle) * radius, y = .76 + Math.sin(angle) * radius / 2.45;
          if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y);
        }
        ctx.closePath(); ctx.stroke(); ctx.fill();
      } else if (id === 6) {
        const mist = ctx.createLinearGradient(.77, .73, .81, .36);
        mist.addColorStop(0, `rgba(${rgb},0)`); mist.addColorStop(.4, `rgba(${rgb},.13)`); mist.addColorStop(1, `rgba(${rgb},0)`);
        ctx.strokeStyle = mist; ctx.lineWidth = .014;
        ctx.beginPath(); ctx.moveTo(.78, .73); ctx.bezierCurveTo(.84, .61, .735, .48, .803, .36); ctx.stroke();
      } else if (id === 0 || id === 5 || id === 8 || id === 10 || id === 13) {
        const count = id === 10 ? 3 : id === 8 ? 4 : 7;
        for (let line = 0; line < count; line++) {
          ctx.beginPath();
          for (let i = 0; i <= 100; i++) {
            const x = .18 + i * .0064;
            let y = .69 + line * .023 + Math.sin(x * (id === 5 ? 19 : 8) + line) * .008;
            if (id === 10) y = .76 + Math.sin(x * 24 + line * 2.094) * .039;
            if (id === 8) y = .76 + Math.sin(x * 15 + line * 1.5) * .033 + Math.sin(x * 7 + line * Math.PI) * .041;
            if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y);
          }
          ctx.stroke();
        }
      }
      ctx.restore();
    }

    releaseGL() {
      if (!this.gl) return;
      if (this.buffer) this.gl.deleteBuffer(this.buffer);
      if (this.program) this.gl.deleteProgram(this.program);
      this.buffer = null;
      this.program = null;
    }

    destroy() {
      if (this.destroyed) return;
      this.destroyed = true;
      this.cancel();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.reducedMotion.removeEventListener) this.reducedMotion.removeEventListener('change', this.onMotion);
      else this.reducedMotion.removeListener(this.onMotion);
      this.canvas.removeEventListener('webglcontextlost', this.onContextLost);
      this.canvas.removeEventListener('webglcontextrestored', this.onContextRestored);
      this.releaseGL();
    }
  };
})();

(() => {
  if (customElements.get('evo-nature-gallery')) return;
  const profiles = {"unda-titanium-pendant":{"name":"UNDA","inspiration":"The movement of water.","motion":"Long, low waves travel across the water; a broad silver reflection bends with the current.","motif":"waves","parameters":{"waterFlow":0.72,"ripple":0.55,"wind":0.26,"foliage":0.2,"spiral":0.08,"lift":0.08,"direction":1,"pulse":0.22,"spread":0.82,"tint":"#91b8bd"}},"ramus-titanium-necklace":{"name":"RAMUS","inspiration":"Branches growing, dividing and reconnecting.","motion":"Branch silhouettes lean gently into a breeze; their reflected shadows divide into fine moving tributaries.","motif":"branches","parameters":{"waterFlow":0.26,"ripple":0.21,"wind":0.49,"foliage":0.85,"spiral":0.02,"lift":0.1,"direction":-1,"pulse":0.18,"spread":0.75,"tint":"#849b7d"}},"voluta-titanium-pendant":{"name":"VOLUTA","inspiration":"Spiralling surfaces in a continuous flow.","motion":"A wide, open curl of reflected light slowly unfurls across the water before joining the current.","motif":"unfurling-spiral","parameters":{"waterFlow":0.45,"ripple":0.22,"wind":0.22,"foliage":0.26,"spiral":0.65,"lift":0.12,"direction":1,"pulse":0.28,"spread":0.9,"tint":"#8fa9a5"}},"gemma-titanium-pendant":{"name":"GEMMA","inspiration":"The first stages of growth.","motion":"Small pools of light open slowly near the reeds, like buds unfolding; close-set ripples spread outward.","motif":"budding","parameters":{"waterFlow":0.18,"ripple":0.36,"wind":0.17,"foliage":0.61,"spiral":0.04,"lift":0.25,"direction":1,"pulse":0.61,"spread":0.3,"tint":"#a0ad86"}},"spira-titanium-pendant":{"name":"SPIRA","inspiration":"Twisting elements held in balance.","motion":"Two soft eddies turn in opposing directions, easing toward each other and apart in a balanced rhythm.","motif":"balanced-eddies","parameters":{"waterFlow":0.32,"ripple":0.33,"wind":0.24,"foliage":0.23,"spiral":0.54,"lift":0.09,"direction":-1,"pulse":0.43,"spread":0.52,"tint":"#9bafb5"}},"plica-titanium-pendant":{"name":"PLICA","inspiration":"An organic surface between movement and stillness.","motion":"Closely spaced water ridges gather into soft folds, then flatten into a quiet reflection.","motif":"folded-ripples","parameters":{"waterFlow":0.28,"ripple":0.62,"wind":0.15,"foliage":0.17,"spiral":0.03,"lift":0.06,"direction":-1,"pulse":0.54,"spread":0.66,"tint":"#a4b0aa"}},"flamma-titanium-pendant":{"name":"FLAMMA","inspiration":"The upward movement of a flame.","motion":"A slender ribbon of mist and muted warm light rises above the water in a slow, tapering curve.","motif":"rising-mist","parameters":{"waterFlow":0.25,"ripple":0.17,"wind":0.32,"foliage":0.21,"spiral":0.18,"lift":0.76,"direction":1,"pulse":0.38,"spread":0.32,"tint":"#b7a180"}},"petalon-titanium-pendant":{"name":"PETALON","inspiration":"Soft leaf and petal forms.","motion":"Broad, soft leaf shadows drift diagonally over the water, each tilting slightly as the breeze passes.","motif":"drifting-petals","parameters":{"waterFlow":0.3,"ripple":0.21,"wind":0.4,"foliage":0.7,"spiral":0.12,"lift":0.22,"direction":1,"pulse":0.24,"spread":0.73,"tint":"#acaa94"}},"plexus-titanium-pendant":{"name":"PLEXUS","inspiration":"A network that branches, separates and reconnects.","motion":"Fine reflected currents separate into a loose network, then reconnect between softly swaying reeds.","motif":"connected-currents","parameters":{"waterFlow":0.42,"ripple":0.35,"wind":0.31,"foliage":0.58,"spiral":0.16,"lift":0.07,"direction":-1,"pulse":0.35,"spread":0.88,"tint":"#829f91"}},"nodus-titanium-pendant":{"name":"NODUS","inspiration":"Interlocking curves and connection.","motion":"Two offset rings spread across the surface, intersecting into a quiet, knot-like pattern of light.","motif":"interlocking-rings","parameters":{"waterFlow":0.21,"ripple":0.68,"wind":0.18,"foliage":0.19,"spiral":0.24,"lift":0.05,"direction":1,"pulse":0.41,"spread":0.48,"tint":"#9caaa8"}},"helix-titanium-pendant":{"name":"HELIX","inspiration":"A continuous twist around an open centre.","motion":"Two narrow trails of reflection wind gently around an open central channel, continuing with the current.","motif":"braided-current","parameters":{"waterFlow":0.53,"ripple":0.19,"wind":0.21,"foliage":0.18,"spiral":0.58,"lift":0.14,"direction":-1,"pulse":0.21,"spread":0.44,"tint":"#8fa8bb"}},"vortex-titanium-pendant":{"name":"VORTEX","inspiration":"Flow around a central point.","motion":"A shallow circular current draws a few fine reflections inward, then releases them into the surrounding water.","motif":"inward-swirl","parameters":{"waterFlow":0.41,"ripple":0.31,"wind":0.27,"foliage":0.22,"spiral":0.82,"lift":0.08,"direction":1,"pulse":0.32,"spread":0.38,"tint":"#83aaa9"}},"phyllon-titanium-pendant":{"name":"PHYLLON","inspiration":"The essential geometry of a leaf.","motion":"One elongated leaf shadow sways over the shore; delicate vein-like reflections follow its single central line.","motif":"leaf-veins","parameters":{"waterFlow":0.2,"ripple":0.16,"wind":0.36,"foliage":0.92,"spiral":0.01,"lift":0.13,"direction":-1,"pulse":0.2,"spread":0.4,"tint":"#91a783"}},"fluxus-titanium-pendant":{"name":"FLUXUS","inspiration":"Sweeping surfaces and invisible forces.","motion":"A gentle gust crosses the whole landscape; grasses bow in sequence and a diagonal wake follows over the water.","motif":"passing-gust","parameters":{"waterFlow":0.66,"ripple":0.29,"wind":0.73,"foliage":0.54,"spiral":0.1,"lift":0.2,"direction":1,"pulse":0.48,"spread":0.96,"tint":"#8faeac"}},"anthos-titanium-pendant":{"name":"ANTHOS","inspiration":"Curved elements unfolding around a centre.","motion":"A low rosette of reflected light opens around a quiet centre, sending rounded, petal-like ripples outward.","motif":"opening-rosette","parameters":{"waterFlow":0.22,"ripple":0.49,"wind":0.23,"foliage":0.47,"spiral":0.21,"lift":0.19,"direction":1,"pulse":0.65,"spread":0.69,"tint":"#b1ac96"}},"orbis-titanium-pendant":{"name":"ORBIS","inspiration":"A continuous form exploring the circle.","motion":"One clear, wide ring of light expands evenly across still water, fading before the next circle begins.","motif":"concentric-ring","parameters":{"waterFlow":0.12,"ripple":0.75,"wind":0.12,"foliage":0.15,"spiral":0,"lift":0.04,"direction":1,"pulse":0.34,"spread":0.94,"tint":"#a6b8b5"}}};
  class NatureGallery extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.controller || !this.isConnected) return;
      this.items = [...this.querySelectorAll('[data-nature-form]')];
      if (!this.items.length) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduce.matches || !!navigator.connection?.saveData;
      this.index = 0;
      this.timers = new Set();
      this.pick = this.querySelector('[data-nature-choose]');
      this.pauseButton = this.querySelector('[data-nature-pause]');
      this.details = this.querySelector('[data-nature-details]');
      this.visible = false;
      this.items.forEach((item, index) => {
        item.addEventListener('click', () => this.select(index), { signal });
      });
      this.querySelector('[data-nature-prev]').addEventListener('click', () => this.select(this.index - 1), { signal });
      this.querySelector('[data-nature-next]').addEventListener('click', () => this.select(this.index + 1), { signal });
      this.pick.addEventListener('change', () => this.select(Number(this.pick.value)), { signal });
      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.playback();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.target.closest('select,a') || event.altKey || event.ctrlKey || event.metaKey) return;
        const target = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.items.length - 1 }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        this.select(target);
        if (event.target.closest('[data-nature-form]')) this.items[this.index].focus({ preventScroll: true });
      }, { signal });
      const stage = this.querySelector('[data-nature-stage]');
      let touch = null;
      stage.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') touch = { x: event.clientX, y: event.clientY };
      }, { signal, passive: true });
      stage.addEventListener('pointerup', event => {
        if (!touch) return;
        const dx = event.clientX - touch.x, dy = event.clientY - touch.y;
        touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          this.suppressClickUntil = performance.now() + 400;
          this.select(this.index + (dx < 0 ? 1 : -1));
        }
      }, { signal, passive: true });
      stage.addEventListener('pointercancel', () => { touch = null; }, { signal });
      stage.addEventListener('click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      }, { signal, capture: true });
      this.reduce.addEventListener('change', () => {
        if (this.reduce.matches) this.paused = true;
        this.playback();
      }, { signal });
      document.addEventListener('visibilitychange', () => this.playback(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.items.findIndex(item => item.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible && !this.landscape && window.EloviumNatureLandscape) {
          this.landscape = new window.EloviumNatureLandscape(this.querySelector('[data-nature-landscape]'));
          this.landscape.setProfile({ ...this.profile().parameters, motif: this.profile().motif });
        }
        this.playback();
      }, { rootMargin: '40px' });
      this.observer.observe(this);
      this.hiddenObserver = new MutationObserver(() => this.playback());
      this.hiddenObserver.observe(this, { attributes: true, attributeFilter: ['hidden'] });
      this.dataset.ready = 'true';
      this.select(0, true);
      this.playback();
    }
    profile() {
      return profiles[this.items[this.index].dataset.handle] || { inspiration: '', parameters: {} };
    }
    select(index, initial = false) {
      const count = this.items.length;
      this.index = ((index % count) + count) % count;
      this.timers.forEach(clearTimeout); this.timers.clear();
      this.items.forEach((item, position) => {
        let slot = (position - this.index + count) % count;
        if (slot > count / 2) slot -= count;
        const shown = Math.abs(slot) <= 2;
        const viewer = item.querySelector('evo-model-viewer');
        item.tabIndex = shown ? 0 : -1;
        item.setAttribute('aria-pressed', String(slot === 0));
        item.setAttribute('aria-hidden', String(!shown));
        if (shown) {
          item.hidden = false;
          if (!viewer.dataset.modelUrl) viewer.dataset.modelUrl = item.dataset.modelUrl;
          if (!viewer.dataset.poster) viewer.dataset.poster = item.dataset.poster;
          viewer.yaw = slot === 0 ? .08 : slot * -.16;
          viewer.pitch = -.03; viewer.dirty = true;
          item.dataset.slot = String(slot);
        } else {
          item.dataset.slot = 'hidden';
          if (initial || this.reduce.matches) item.hidden = true;
          else {
            const timer = setTimeout(() => { item.hidden = true; this.timers.delete(timer); }, 850);
            this.timers.add(timer);
          }
        }
      });
      const selected = this.items[this.index];
      const profile = this.profile();
      this.details.querySelector('[data-nature-name]').textContent = selected.dataset.name;
      this.details.querySelector('[data-nature-description]').textContent = selected.dataset.description;
      this.details.querySelector('[data-nature-price]').textContent = selected.dataset.price;
      this.details.querySelector('[data-nature-inspiration]').textContent = profile.inspiration;
      this.details.querySelector('[data-nature-visit]').href = selected.dataset.url;
      this.pick.value = String(this.index);
      this.querySelector('[data-nature-count]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(count).padStart(2, '0')}`;
      this.dataset.activeHandle = selected.dataset.handle;
      this.dataset.motif = profile.motif || '';
      this.landscape?.setProfile({ ...profile.parameters, motif: profile.motif });
      this.dispatchEvent(new CustomEvent('nature:change', { bubbles: true, detail: { index: this.index, handle: selected.dataset.handle } }));
    }
    playback() {
      const stopped = this.paused || this.reduce.matches || !this.visible || this.hidden || document.hidden;
      this.landscape?.setPaused(stopped);
      this.pauseButton.hidden = this.reduce.matches;
      this.pauseButton.textContent = this.paused || this.reduce.matches ? this.pauseButton.dataset.play : this.pauseButton.dataset.pause;
      this.pauseButton.setAttribute('aria-pressed', String(this.paused || this.reduce.matches));
      this.dataset.paused = String(stopped);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); this.hiddenObserver?.disconnect();
      this.timers?.forEach(clearTimeout);
      this.landscape?.destroy(); this.landscape = null;
      delete this.dataset.ready;
    }
  }
  customElements.define('evo-nature-gallery', NatureGallery);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-product-media-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('evo-product-gallery')) return;
  class EloviumProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      const signal = this.controller.signal;
      this.modes = Array.from(this.querySelectorAll('[data-media-mode]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-media-target]'));
      this.panels = Array.from(this.querySelectorAll('[data-media-panel]'));
      this.photo = this.querySelector('[data-media-photo]');
      this.dialog = this.querySelector('dialog');
      this.dialogBody = this.querySelector('[data-media-dialog-body]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userPaused = this.motion.matches;
      this.activeKey = 'photo';
      this.thumbs.filter(node => node.tagName === 'A').forEach(node => node.setAttribute('role', 'button'));
      this.querySelectorAll('[data-media-enhance]').forEach(node => node.hidden = false);
      this.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('a[data-media-target]')) { event.preventDefault(); event.target.click(); }
      }, { signal });
      this.addEventListener('click', event => {
        const target = event.target.closest('[data-media-target]');
        const mode = event.target.closest('[data-media-mode]');
        if (target) { event.preventDefault(); this.select(target.dataset.mediaTarget, target); }
        if (mode) this.select(mode.dataset.mediaMode);
        if (event.target.closest('[data-media-toggle]')) { this.userPaused = !this.userPaused; this.syncPlayback(); }
        if (event.target.closest('[data-media-reset]')) this.activeViewer()?.resetView?.();
        if (event.target.closest('[data-media-expand]')) this.openFullView(event.target.closest('[data-media-expand]'));
        if (event.target.closest('[data-media-close]')) this.dialog.close();
      }, { signal });
      this.addEventListener('model-error', event => {
        if (!event.target.matches('evo-model-viewer')) return;
        this.querySelector('[data-media-error]').hidden = false;
      }, { signal });
      this.addEventListener('model-loaded', event => {
        if (event.target.matches('evo-model-viewer')) this.querySelector('[data-media-error]').hidden = true;
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.dialogBody.querySelector('video')?.pause();
        this.dialogBody.querySelector('evo-model-viewer')?.setAttribute('paused', '');
        this.dialogBody.replaceChildren();
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.syncPlayback();
        this.zoomTrigger?.focus();
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.panels.forEach(panel => {
        const video = panel.querySelector('video');
        if (!video) return;
        video.addEventListener('error', () => {
          panel.dataset.mediaFailed = 'true';
          if (panel.dataset.mediaPanel === this.activeKey) this.select('photo');
        }, { signal });
      });
      this.motion.addEventListener('change', () => {
        this.userPaused = this.motion.matches;
        this.syncPlayback();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.dialogBody.querySelector('video')?.pause();
        this.syncPlayback();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.syncPlayback();
      }, { threshold: 0.12 });
      this.observer.observe(this.querySelector('[data-media-stage]'));
      this.select('photo');
    }
    select(key, thumb) {
      const panel = this.panels.find(node => node.dataset.mediaPanel === key);
      if (!panel || panel.dataset.mediaFailed === 'true') return;
      this.activeKey = key;
      this.panels.forEach(node => node.hidden = node !== panel);
      if (panel.querySelector('evo-model-viewer.has-error')) this.querySelector('[data-media-error]').hidden = false;
      if (key === 'photo' && thumb?.dataset.mediaSrc && this.photo) {
        this.photo.src = thumb.dataset.mediaSrc;
        this.photo.srcset = '';
        this.photo.alt = thumb.dataset.mediaAlt || '';
        this.selectedPhoto = thumb;
      }
      if (key === 'photo' && !this.selectedPhoto) this.selectedPhoto = this.thumbs.find(node => node.dataset.mediaTarget === 'photo');
      this.thumbs.forEach(node => node.setAttribute('aria-pressed', String(key === 'photo' ? node === this.selectedPhoto : node.dataset.mediaTarget === key)));
      this.modes.forEach(node => node.setAttribute('aria-pressed', String(node.dataset.mediaMode === key || node.dataset.mediaMode === 'photo' && key.startsWith('film-'))));
      this.querySelectorAll('[data-render-note]').forEach(node => node.hidden = key !== 'rotation');
      this.querySelectorAll('[data-photo-note]').forEach(node => node.hidden = key !== 'photo');
      this.querySelectorAll('.evo-product-media__tools [data-media-toggle],.evo-product-media__tools [data-media-reset]').forEach(node => node.hidden = key !== 'rotation');
      this.querySelector('[data-media-caption]').textContent = key === 'photo' && thumb ? '' : panel.dataset.caption || '';
      this.syncPlayback();
    }
    activeViewer() {
      return this.dialog.open ? this.dialogBody.querySelector('evo-model-viewer') : this.panels.find(panel => panel.dataset.mediaPanel === this.activeKey)?.querySelector('evo-model-viewer');
    }
    loadVideo(video) {
      if (video.dataset.loaded === 'true') return;
      video.querySelectorAll('source[data-src]').forEach(source => source.src = source.dataset.src);
      video.dataset.loaded = 'true';
      video.load();
    }
    syncPlayback() {
      this.panels.forEach(panel => {
        const active = panel.dataset.mediaPanel === this.activeKey && this.visible && !document.hidden && !this.dialog.open;
        const viewer = panel.querySelector('evo-model-viewer');
        if (viewer) viewer.toggleAttribute('paused', !active || this.userPaused);
        const video = panel.querySelector('video');
        if (!video) return;
        if (!active) video.pause();
        else this.loadVideo(video);
      });
      const modalViewer = this.dialogBody.querySelector('evo-model-viewer');
      if (modalViewer) modalViewer.toggleAttribute('paused', !this.dialog.open || document.hidden || this.userPaused);
      this.updateControls();
    }
    updateControls() {
      const viewer = this.activeViewer();
      const rotating = Boolean(viewer && !viewer.hasAttribute('paused'));
      this.querySelectorAll('[data-media-toggle]').forEach(button => {
        button.hidden = !viewer || this.motion.matches || Boolean(navigator.connection?.saveData);
        button.setAttribute('aria-pressed', String(rotating));
        button.querySelector('[data-media-toggle-label]').textContent = rotating ? button.dataset.pause : button.dataset.play;
        button.querySelector('[data-media-toggle-symbol]').textContent = rotating ? 'Ⅱ' : '▷';
      });
    }
    openFullView(trigger) {
      const panel = this.panels.find(node => node.dataset.mediaPanel === this.activeKey);
      const original = panel?.querySelector('evo-model-viewer,video,img');
      if (!original || this.dialog.open) return;
      this.zoomTrigger = trigger;
      this.previousOverflow = document.documentElement.style.overflow;
      const isModel = original.matches('evo-model-viewer');
      let clone;
      if (isModel) {
        clone = document.createElement('evo-model-viewer');
        ['data-model-url', 'data-poster', 'data-label', 'aria-label', 'aria-describedby', 'tabindex', 'role'].forEach(name => {
          if (original.hasAttribute(name)) clone.setAttribute(name, original.getAttribute(name));
        });
        clone.setAttribute('paused', '');
      } else {
        clone = original.cloneNode(true);
        if (clone.tagName === 'VIDEO') {
          const wasPlaying = !original.paused;
          clone.controls = true;
          clone.removeAttribute('data-loaded');
          clone.preload = 'metadata';
          clone.removeAttribute('autoplay');
          this.loadVideo(clone);
          clone.addEventListener('loadedmetadata', () => {
            if (Number.isFinite(original.currentTime)) clone.currentTime = original.currentTime;
            if (wasPlaying && !document.hidden) clone.play().catch(() => {});
          }, { once: true });
        } else { clone.loading = 'eager'; clone.removeAttribute('fetchpriority'); }
      }
      this.dialogBody.replaceChildren(clone);
      this.querySelector('[data-dialog-model-tools]').hidden = !isModel;
      this.dialog.classList.toggle('has-model', isModel);
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.syncPlayback();
      if (isModel) requestAnimationFrame(() => clone.focus());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.querySelectorAll('evo-model-viewer').forEach(viewer => viewer.setAttribute('paused', ''));
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.previousOverflow || ''; }
    }
  }
  customElements.define('evo-product-gallery', EloviumProductGallery);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-rings-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(scope=document){
    scope.querySelectorAll('[data-ring-page]').forEach(page=>{
      if(page.dataset.ringBound)return;page.dataset.ringBound='true';
      const viewer=page.querySelector('evo-model-viewer'),start=page.querySelector('[data-ring-activate]'),reset=page.querySelector('[data-ring-reset]'),status=page.querySelector('[data-ring-status]'),stage=page.querySelector('[data-ring-stage]');
      if(!viewer||!start)return;
      const preview=page.querySelector('.er-preview'),options=[...page.querySelectorAll('[data-ring-option]')];
      const unsupported=viewer.classList.contains('has-error');
      options.forEach(option=>option.addEventListener('click',()=>{
        if(option.getAttribute('aria-pressed')==='true')return;
        options.forEach(item=>item.setAttribute('aria-pressed',String(item===option)));
        viewer.hidden=true;viewer.removeAttribute('data-model-url');viewer.dataset.ringUrl=option.dataset.url;viewer.dataset.poster=option.dataset.poster;viewer.resetView();
        if(!unsupported)viewer.classList.remove('has-error');
        preview.removeAttribute('srcset');preview.src=option.dataset.poster;preview.alt=option.dataset.name;
        page.querySelector('[data-ring-name]').textContent=option.dataset.name;
        page.querySelector('[data-ring-description]').textContent=option.dataset.copy;
        stage.classList.remove('is-ready');start.hidden=false;start.disabled=false;reset.hidden=true;status.textContent=status.dataset.initial;
      }));
      start.addEventListener('click',()=>{
        if(unsupported||!customElements.get('evo-model-viewer')){status.textContent=status.dataset.error;return;}
        status.textContent=status.dataset.loading;start.disabled=true;viewer.hidden=false;
        viewer.setAttribute('data-model-url',viewer.dataset.ringUrl);
        viewer.loadModel();
      });
      viewer.addEventListener('model-loaded',()=>{stage.classList.add('is-ready');start.hidden=true;reset.hidden=false;status.textContent=status.dataset.ready;viewer.focus({preventScroll:true});});
      viewer.addEventListener('model-error',()=>{stage.classList.remove('is-ready');viewer.hidden=true;start.hidden=false;start.disabled=false;reset.hidden=true;status.textContent=status.dataset.error;});
      reset.addEventListener('click',()=>{viewer.resetView();viewer.focus({preventScroll:true});});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-sculpture"] && !Shopify.designMode) return;
  try {
    (() => {
 if(window.evoSculptureLoaded)return;window.evoSculptureLoaded=true;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),cleanups=new WeakMap();
 const init=root=>{
  if(cleanups.has(root))return;
  const video=root.querySelector('video'),button=root.querySelector('[data-sculpture-toggle]');if(!video||!button)return;
  const abort=new AbortController(),signal=abort.signal;let visible=false,manual=false;
  const label=button.querySelector('[data-sculpture-state]'),symbol=button.querySelector('[aria-hidden]');
  const update=()=>{const text=video.paused?root.dataset.playLabel:root.dataset.pauseLabel;label.textContent=text;button.setAttribute('aria-label',text);symbol.textContent=video.paused?'▷':'Ⅱ';};
  const play=()=>video.play().catch(()=>update());
  const permitted=()=>!manual&&!reduced.matches&&!navigator.connection?.saveData&&!document.hidden;
  video.controls=false;button.hidden=false;
  button.addEventListener('click',()=>{manual=!video.paused;if(video.paused)play();else video.pause();},{signal});
  video.addEventListener('play',update,{signal});video.addEventListener('pause',update,{signal});
  video.addEventListener('error',()=>{video.controls=true;button.hidden=true;},{signal});
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible&&permitted())play();else if(!visible)video.pause();},{threshold:.3});observer.observe(video);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(visible&&permitted())play();},{signal});
  reduced.addEventListener('change',()=>{if(reduced.matches)video.pause();},{signal});
  update();cleanups.set(root,()=>{video.pause();observer.disconnect();abort.abort();});
 };
 const all=(scope=document)=>scope.querySelectorAll('[data-sculpture-media]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>all(),{once:true});else all();
 document.addEventListener('shopify:section:load',e=>all(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-sculpture-media]').forEach(root=>{cleanups.get(root)?.();cleanups.delete(root);}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-webgl-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('evo-model-viewer')) return;
  const instances=new Set(), cache=new Map(), reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const clamp=(v,a,b)=>Math.min(b,Math.max(a,v));
  const frontOffset=url=>/\/elovium-eln-(001|003|010)-interactive\.glb(?:[?#]|$)/i.test(url||'')?Math.PI:0;
  const surface=document.createElement('canvas');
  const gl=surface.getContext('webgl',{alpha:true,antialias:true,premultipliedAlpha:true,preserveDrawingBuffer:true,powerPreference:'high-performance'});
  const surfaceDerivatives=gl&&gl.getExtension('OES_standard_derivatives');
  let rendererError=false;
  const vertex=`
    precision highp float;
    attribute vec3 aPosition; attribute vec3 aNormal; attribute float aSeed;
    uniform mat3 uRotation; uniform float uAspect; uniform float uScale;
    uniform float uParticle; uniform float uProgress; uniform float uTime; uniform float uStage; uniform float uPixel;
    varying vec3 vNormal; varying vec3 vWorld; varying vec3 vLocal; varying vec3 vObjectNormal; varying float vSeed;
    void main(){
      vec3 pos=aPosition; vSeed=aSeed;
      if(uParticle>0.5){
        float angle=aSeed*6.2831853;
        float radius=1.25+fract(aSeed*19.317)*1.0;
        vec3 cloud=vec3(cos(angle+uTime*.10)*radius,(fract(aSeed*37.13)-.5)*2.8,sin(angle+uTime*.10)*radius);
        if(uStage<2.5){
          float p=clamp((uProgress-fract(aSeed*17.37)*.17)/.83,0.,1.);
          float eased=1.-pow(1.-p,3.);
          cloud.x+=sin(p*6.2831853+aSeed*20.)*(1.-eased)*.4;
          pos=mix(cloud,aPosition,eased);
        }else{
          float threshold=(aPosition.y+1.)*.5;
          vec3 powder=vec3(cos(angle)*radius*.8,-1.05,sin(angle)*radius*.8);
          float join=smoothstep(threshold-.12,threshold+.015,uProgress);
          pos=mix(powder,aPosition,join);
        }
      }
      vec3 world=uRotation*pos; vNormal=normalize(uRotation*aNormal); vWorld=world; vLocal=aPosition; vObjectNormal=aNormal;
      vec3 view=world-vec3(0.,0.,4.7);
      float focal=3.45*uScale;
      gl_Position=vec4(view.x*focal/uAspect,view.y*focal,-1.004*view.z-.2004,-view.z);
      gl_PointSize=uParticle>.5?clamp(uPixel*(1.0+fract(aSeed*13.1)*1.0),1.,5.):1.;
    }`;
  const fragment=`
    ${surfaceDerivatives?'#extension GL_OES_standard_derivatives : enable\n#define SURFACE_DERIVATIVES 1':''}
    precision highp float;
    uniform mat3 uRotation;
    uniform float uParticle; uniform float uProgress; uniform float uTime; uniform float uStage; uniform float uSolid; uniform float uWire;
    varying vec3 vNormal; varying vec3 vWorld; varying vec3 vLocal; varying vec3 vObjectNormal; varying float vSeed;
    float hash(vec3 p){return fract(sin(dot(p,vec3(12.9898,78.233,45.164)))*43758.5453);}
    vec4 grain(vec3 p){
      vec3 cell=floor(p),f=fract(p),u=f*f*(3.-2.*f),du=6.*f*(1.-f);
      float a=hash(cell),b=hash(cell+vec3(1.,0.,0.)),c=hash(cell+vec3(0.,1.,0.)),d=hash(cell+vec3(1.,1.,0.));
      float e=hash(cell+vec3(0.,0.,1.)),f1=hash(cell+vec3(1.,0.,1.)),g=hash(cell+vec3(0.,1.,1.)),h=hash(cell+vec3(1.,1.,1.));
      float k1=b-a,k2=c-a,k3=e-a,k4=a-b-c+d,k5=a-c-e+g,k6=a-b-e+f1,k7=-a+b+c-d+e-f1-g+h;
      float value=a+k1*u.x+k2*u.y+k3*u.z+k4*u.x*u.y+k5*u.y*u.z+k6*u.z*u.x+k7*u.x*u.y*u.z;
      vec3 gradient=du*vec3(k1+k4*u.y+k6*u.z+k7*u.y*u.z,k2+k4*u.x+k5*u.z+k7*u.z*u.x,k3+k5*u.y+k6*u.x+k7*u.x*u.y);
      return vec4(gradient,value);
    }
    vec3 environment(vec3 d,float roughness){
      float upper=smoothstep(-.65,.9,d.y);
      vec3 c=mix(vec3(.05,.051,.052),vec3(.25,.25,.245),upper);
      float key=pow(max(0.,dot(d,normalize(vec3(-.72,.6,1.)))),mix(22.,9.,roughness));
      float rim=pow(max(0.,dot(d,normalize(vec3(.9,.25,.5)))),mix(42.,18.,roughness));
      float ceiling=pow(max(0.,dot(d,normalize(vec3(-.15,1.,.15)))),8.);
      float front=pow(max(0.,dot(d,normalize(vec3(-.25,.15,1.)))),6.);
      return c+vec3(3.2,3.12,3.0)*key+vec3(1.65,1.68,1.70)*rim+vec3(.45,.45,.44)*ceiling+vec3(.38)*front;
    }
    void main(){
      if(uParticle>.5){
        vec2 q=gl_PointCoord-.5; float radius=length(q); if(radius>.5)discard;
        float alpha=(1.-smoothstep(.14,.5,radius))*.82;
        if(uStage<2.5)alpha*=smoothstep(0.,.12,uProgress)*(1.-smoothstep(.82,1.,uProgress));
        else alpha*=1.-smoothstep((vLocal.y+1.)*.5-.03,(vLocal.y+1.)*.5+.04,uProgress);
        gl_FragColor=vec4(mix(vec3(.48,.54,.57),vec3(.87,.89,.88),fract(vSeed*11.)),alpha);return;
      }
      float clipY=-1.04+uProgress*2.09;
      float alpha=uSolid;
      if(uStage>2.5&&uStage<3.5&&vLocal.y>clipY){alpha=.045;}
      vec3 N=normalize(vNormal); if(!gl_FrontFacing)N=-N;
      vec3 objectN=normalize(vObjectNormal); if(!gl_FrontFacing)objectN=-objectN;
      float footprint=.009;
      #ifdef SURFACE_DERIVATIVES
      footprint=max(length(dFdx(vLocal)),length(dFdy(vLocal)));
      #endif
      float coarseWeight=1.-smoothstep(.45,1.4,footprint*75.);
      float fineWeight=1.-smoothstep(.35,1.25,footprint*210.);
      vec4 coarse=grain(vLocal*75.),fine=grain(vLocal*210.+vec3(7.2,1.8,4.6));
      vec3 relief=coarse.xyz*.20*coarseWeight+fine.xyz*.09*fineWeight;
      relief-=objectN*dot(objectN,relief);
      N=normalize(N-uRotation*relief);
      vec3 V=normalize(vec3(0.,0.,4.7)-vWorld);
      vec3 R=reflect(-V,N);
      float fresnel=pow(1.-max(0.,dot(N,V)),4.);
      float roughness=.52+(coarse.w-.5)*.20*coarseWeight;
      float diffuse=.045+max(0.,dot(N,normalize(vec3(-.6,.8,1.))))*.15+max(0.,dot(N,normalize(vec3(.8,.25,.8))))*.045;
      float texture=1.+(coarse.w-.5)*.12*coarseWeight+(fine.w-.5)*.045*fineWeight;
      vec3 metal=(environment(R,roughness)*(.53+fresnel*.24)+vec3(.34,.34,.335)*diffuse)*texture;
      if(uStage>1.5&&uStage<2.5){
        float develop=smoothstep(0.,.18,uProgress);
        metal=mix(metal,metal*.16+vec3(.09,.14,.14),develop);
        float contour=pow(.5+.5*cos(vLocal.y*130.),24.);
        metal+=vec3(.22,.37,.36)*contour*.6*develop;
        alpha*=1.-smoothstep(.82,1.,uProgress)*.955;
      }
      if(uWire>.5){metal=vec3(.38,.58,.56);alpha=.19*smoothstep(0.,.18,uProgress)*(1.-smoothstep(.78,1.,uProgress));}
      if(uStage>2.5&&uStage<3.5){
        float band=1.-smoothstep(.001,.025,abs(vLocal.y-clipY));
        float point=pow(max(0.,cos(vLocal.x*5.-uTime*7.)),18.);
        metal+=vec3(1.6,.76,.22)*band*(.5+point*2.);
      }
      metal=metal/(metal+vec3(.58)); metal=pow(metal,vec3(.82));
      gl_FragColor=vec4(metal,alpha);
    }`;
  let program,loc;
  if(gl){
    try{
      const compile=(type,source)=>{const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw new Error(gl.getShaderInfoLog(s));return s;};
      program=gl.createProgram();gl.attachShader(program,compile(gl.VERTEX_SHADER,vertex));gl.attachShader(program,compile(gl.FRAGMENT_SHADER,fragment));gl.linkProgram(program);
      if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw new Error(gl.getProgramInfoLog(program));
      loc={};['uRotation','uAspect','uScale','uParticle','uProgress','uTime','uStage','uPixel','uSolid','uWire'].forEach(k=>loc[k]=gl.getUniformLocation(program,k));
      ['aPosition','aNormal','aSeed'].forEach(k=>loc[k]=gl.getAttribLocation(program,k));
      gl.getExtension('OES_element_index_uint');
    }catch(error){rendererError=true;console.error('ELOVIUM 3D renderer:',error.message);}
  }
  const buffer=(data,target=gl.ARRAY_BUFFER)=>{const b=gl.createBuffer();gl.bindBuffer(target,b);gl.bufferData(target,data,gl.STATIC_DRAW);return b;};
  const parse=bytes=>{
    const view=new DataView(bytes);if(view.getUint32(0,true)!==0x46546c67||view.getUint32(4,true)!==2)throw new Error('Unsupported model');
    let doc,bin;for(let offset=12;offset<bytes.byteLength;){const size=view.getUint32(offset,true),type=view.getUint32(offset+4,true);if(type===0x4e4f534a)doc=JSON.parse(new TextDecoder().decode(new Uint8Array(bytes,offset+8,size)));if(type===0x004e4942)bin=offset+8;offset+=8+size;}
    const primitive=doc.meshes[0].primitives[0];if(primitive.extensions?.KHR_draco_mesh_compression)throw new Error('Compressed model unsupported');
    const accessor=index=>{
      const a=doc.accessors[index],b=doc.bufferViews[a.bufferView];const components={SCALAR:1,VEC2:2,VEC3:3,VEC4:4}[a.type];
      const ArrayType={5126:Float32Array,5125:Uint32Array,5123:Uint16Array,5121:Uint8Array}[a.componentType];
      const start=bin+(b.byteOffset||0)+(a.byteOffset||0),stride=b.byteStride||components*ArrayType.BYTES_PER_ELEMENT;
      if(stride===components*ArrayType.BYTES_PER_ELEMENT)return new ArrayType(bytes.slice(start,start+a.count*stride));
      const out=new ArrayType(a.count*components);for(let i=0;i<a.count;i++)out.set(new ArrayType(bytes.slice(start+i*stride,start+i*stride+components*ArrayType.BYTES_PER_ELEMENT)),i*components);return out;
    };
    const positions=accessor(primitive.attributes.POSITION),normals=accessor(primitive.attributes.NORMAL),indices=accessor(primitive.indices);
    const model={positions:buffer(positions),normals:buffer(normals),indices:buffer(indices,gl.ELEMENT_ARRAY_BUFFER),count:indices.length,type:indices instanceof Uint32Array?gl.UNSIGNED_INT:gl.UNSIGNED_SHORT};
    const pointCount=Math.min(16000,positions.length/3),pp=new Float32Array(pointCount*3),pn=new Float32Array(pointCount*3),seeds=new Float32Array(pointCount);
    for(let i=0;i<pointCount;i++){const index=Math.floor(i*(positions.length/3)/pointCount)*3;pp.set(positions.subarray(index,index+3),i*3);pn.set(normals.subarray(index,index+3),i*3);seeds[i]=(Math.sin(i*127.1+311.7)*43758.5453)%1;if(seeds[i]<0)seeds[i]+=1;}
    model.points={positions:buffer(pp),normals:buffer(pn),seeds:buffer(seeds),count:pointCount};
    const edges=new indices.constructor(indices.length*2);for(let i=0,j=0;i<indices.length;i+=3){edges[j++]=indices[i];edges[j++]=indices[i+1];edges[j++]=indices[i+1];edges[j++]=indices[i+2];edges[j++]=indices[i+2];edges[j++]=indices[i];}
    model.edges=buffer(edges,gl.ELEMENT_ARRAY_BUFFER);model.edgeCount=edges.length;return model;
  };
  const getModel=url=>{
    if(!cache.has(url))cache.set(url,fetch(url,{mode:'cors'}).then(r=>{if(!r.ok)throw new Error('Model could not load');return r.arrayBuffer();}).then(parse).catch(error=>{cache.delete(url);throw error;}));
    return cache.get(url);
  };
  const rotation=(yaw,pitch)=>{
    const cy=Math.cos(yaw),sy=Math.sin(yaw),cx=Math.cos(pitch),sx=Math.sin(pitch);
    return new Float32Array([cy,sx*sy,-cx*sy,0,cx,sx,sy,-sx*cy,cx*cy]);
  };
  const attribute=(location,buf,size)=>{gl.bindBuffer(gl.ARRAY_BUFFER,buf);gl.enableVertexAttribArray(location);gl.vertexAttribPointer(location,size,gl.FLOAT,false,0,0);};
  const render=(element,time)=>{
    const {model,width:w,height:h}=element;if(!model||!w||!h)return;
    gl.viewport(0,0,w,h);gl.scissor(0,0,w,h);gl.enable(gl.SCISSOR_TEST);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
    gl.useProgram(program);gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);gl.disable(gl.CULL_FACE);gl.enable(gl.BLEND);gl.blendFuncSeparate(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA,gl.ONE,gl.ONE_MINUS_SRC_ALPHA);
    const process=element.hasAttribute('data-process'),stage=process?({nature:0,form:1,digital:2,layers:3,finish:4}[element.stage]??4):4,p=element.progress??1;
    const yaw=(process?(stage===4?.05+Math.sin(p*1.5)*.32:.06):element.yaw)+frontOffset(element.dataset.modelUrl);
    gl.uniformMatrix3fv(loc.uRotation,false,rotation(yaw,element.pitch));gl.uniform1f(loc.uAspect,w/h);gl.uniform1f(loc.uScale,element.zoom);gl.uniform1f(loc.uStage,stage);gl.uniform1f(loc.uProgress,p);gl.uniform1f(loc.uTime,time);gl.uniform1f(loc.uPixel,element.pixelRatio);gl.uniform1f(loc.uWire,0);
    if(stage!==0){
      if(process&&(stage===1||stage===3)){
        attribute(loc.aPosition,model.points.positions,3);attribute(loc.aNormal,model.points.normals,3);attribute(loc.aSeed,model.points.seeds,1);
        gl.uniform1f(loc.uParticle,1);gl.uniform1f(loc.uSolid,1);gl.depthMask(false);gl.drawArrays(gl.POINTS,0,model.points.count);gl.depthMask(true);
      }
      attribute(loc.aPosition,model.positions,3);attribute(loc.aNormal,model.normals,3);gl.disableVertexAttribArray(loc.aSeed);gl.vertexAttrib1f(loc.aSeed,0);gl.uniform1f(loc.uParticle,0);
      gl.uniform1f(loc.uSolid,stage===1?clamp((p-.72)/.28,0,1):1);gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,model.indices);
      if(stage!==1||p>.72)gl.drawElements(gl.TRIANGLES,model.count,model.type,0);
      if(stage===2){gl.uniform1f(loc.uWire,1);gl.depthMask(false);gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,model.edges);gl.drawElements(gl.LINES,model.edgeCount,model.type,0);gl.depthMask(true);}
    }
    const output=element.context;output.clearRect(0,0,w,h);output.drawImage(surface,0,surface.height-h,w,h,0,0,w,h);
    element.classList.add('is-ready');element.dirty=false;
  };
  let previous=0;
  const frame=now=>{
    requestAnimationFrame(frame);if(document.hidden||!gl||rendererError)return;
    const active=[...instances].filter(v=>v.visible&&v.model&&v.clientWidth&&v.clientHeight&&!v.closest('[hidden]'));
    if(!active.length)return;
    const dragging=active.some(v=>v.dragging),interval=dragging?16:32;if(now-previous<interval)return;
    const delta=Math.min((now-previous)/1000,.08);previous=now;
    let width=1,height=1;
    active.forEach(v=>{v.measure();width=Math.max(width,v.width);height=Math.max(height,v.height);});
    if(surface.width!==width||surface.height!==height){surface.width=width;surface.height=height;active.forEach(v=>v.dirty=true);}
    for(const v of active){
      const auto=!v.hasAttribute('paused')&&!reduced.matches&&!navigator.connection?.saveData&&!v.dragging&&now>v.manualUntil&&!v.hasAttribute('data-process');
      if(auto){v.yaw+=delta*.20;v.dirty=true;}
      if(v.dirty)render(v,now/1000);
    }
  };
  class ModelViewer extends HTMLElement{
    static get observedAttributes(){return ['data-model-url','data-poster','paused'];}
    constructor(){super();this.yaw=.08;this.pitch=-.03;this.zoom=1;this.progress=1;this.stage='finish';this.manualUntil=0;this.dirty=true;this.modelReady=false;}
    connectedCallback(){
      if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;instances.add(this);
      this.poster=document.createElement('img');this.poster.className='evo-model-poster';this.poster.alt='';this.poster.loading='lazy';this.append(this.poster);this.updatePoster();
      this.canvas=document.createElement('canvas');this.canvas.setAttribute('aria-hidden','true');this.append(this.canvas);this.context=this.canvas.getContext('2d',{alpha:true});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible){this.loadModel();this.dirty=true;}},{rootMargin:'40px',threshold:0});this.observer.observe(this);
      this.resize=new ResizeObserver(()=>{this.measure();this.dirty=true;});this.resize.observe(this);
      this.addEventListener('pointerdown',e=>{if(this.hasAttribute('data-process')||e.button!==0)return;this.focus({preventScroll:true});this.dragging=true;this.lastX=e.clientX;this.lastY=e.clientY;this.startX=e.clientX;this.startY=e.clientY;this.setPointerCapture(e.pointerId);},{signal});
      this.addEventListener('wheel',e=>{if(this.hasAttribute('data-process')||this.hasAttribute('data-no-zoom')||document.activeElement!==this)return;e.preventDefault();this.zoom=clamp(this.zoom-e.deltaY*.001,.72,1.55);this.manualUntil=performance.now()+4500;this.dirty=true;},{signal,passive:false});
      this.addEventListener('pointermove',e=>{if(!this.dragging)return;this.yaw+=(e.clientX-this.lastX)*.010;this.pitch=clamp(this.pitch+(e.clientY-this.lastY)*.008,-1.18,1.18);this.lastX=e.clientX;this.lastY=e.clientY;this.dirty=true;},{signal});
      const end=()=>{this.dragging=false;this.manualUntil=performance.now()+4500;};this.addEventListener('pointerup',end,{signal});this.addEventListener('pointercancel',end,{signal});
      this.addEventListener('keydown',e=>{if(this.hasAttribute('data-process'))return;const steps={ArrowLeft:[-.18,0],ArrowRight:[.18,0],ArrowUp:[0,-.15],ArrowDown:[0,.15]};if(steps[e.key]){e.preventDefault();this.yaw+=steps[e.key][0];this.pitch=clamp(this.pitch+steps[e.key][1],-1.18,1.18);this.manualUntil=performance.now()+4500;this.dirty=true;}else if(e.key==='Home'){e.preventDefault();this.resetView();}},{signal});
      if(!gl||rendererError){this.classList.add('has-error');this.dispatchEvent(new CustomEvent('model-error',{bubbles:true}));}
    }
    attributeChangedCallback(name,oldValue,newValue){if(oldValue===newValue)return;if(name==='data-model-url'){this.model=null;this.loadedUrl=null;this.modelReady=false;this.classList.remove('is-ready');if(this.visible)this.loadModel();}else if(name==='data-poster')this.updatePoster();this.dirty=true;}
    updatePoster(){if(this.poster){const src=this.dataset.poster;if(src)this.poster.src=src;else this.poster.removeAttribute('src');}}
    async loadModel(){
      const url=this.dataset.modelUrl;if(!url||!gl||rendererError||this.loadingUrl===url||(this.loadedUrl===url&&this.model))return;
      this.loadingUrl=url;try{const model=await getModel(url);if(!this.isConnected||this.dataset.modelUrl!==url)return;this.model=model;this.loadedUrl=url;this.modelReady=true;this.dirty=true;this.classList.remove('has-error');this.dispatchEvent(new CustomEvent('model-loaded',{bubbles:true}));}catch(error){this.classList.add('has-error');this.dispatchEvent(new CustomEvent('model-error',{bubbles:true,detail:error.message}));}finally{this.loadingUrl=null;}
    }
    measure(){const rect=this.getBoundingClientRect();this.pixelRatio=Math.min(devicePixelRatio||1,this.closest('[data-form-gallery]')?2:2.5,1800/Math.max(rect.width,rect.height,1));this.width=Math.max(1,Math.round(rect.width*this.pixelRatio));this.height=Math.max(1,Math.round(rect.height*this.pixelRatio));if(this.canvas&&(this.canvas.width!==this.width||this.canvas.height!==this.height)){this.canvas.width=this.width;this.canvas.height=this.height;this.dirty=true;}}
    pause(){this.setAttribute('paused','');}
    resume(){this.removeAttribute('paused');this.dirty=true;}
    resetView(){this.yaw=.08;this.pitch=-.03;this.zoom=1;this.manualUntil=performance.now()+3000;this.dirty=true;}
    setProgress(progress){this.setStage('form',progress);}
    setStage(stage,progress){this.stage=stage;this.progress=clamp(progress,0,1);this.dirty=true;}
    disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.resize?.disconnect();instances.delete(this);this.poster?.remove();this.canvas?.remove();}
  }
  customElements.define('evo-model-viewer',ModelViewer);requestAnimationFrame(frame);
})();
  } catch(e) { console.error(e); }
})();

})();
